import {
  Box,
  IconButton,
  useTheme,
  Typography,
  Breadcrumbs,
  Tooltip,
  Chip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  TextField,
  Button,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Stack,
  InputAdornment,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
} from "@mui/material";
import Swal from "sweetalert2";
import RecentActorsIcon from "@mui/icons-material/RecentActors";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import ContactSupportIcon from "@mui/icons-material/ContactSupport";
import DoneOutlineIcon from "@mui/icons-material/DoneOutline";
import LockResetIcon from "@mui/icons-material/LockReset";
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";
import RedoIcon from "@mui/icons-material/Redo";
import UndoIcon from "@mui/icons-material/Undo";
import BlockIcon from "@mui/icons-material/Block";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import EmailIcon from "@mui/icons-material/Email";
import ViewInArOutlinedIcon from "@mui/icons-material/ViewInArOutlined";
import ListAltOutlinedIcon from "@mui/icons-material/ListAltOutlined";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import AddPhotoAlternateIcon from "@mui/icons-material/AddPhotoAlternate";
import AssessmentIcon from "@mui/icons-material/Assessment";
import ModeEditOutlinedIcon from "@mui/icons-material/ModeEditOutlined";
import SummarizeOutlinedIcon from "@mui/icons-material/SummarizeOutlined";
import TaskAltOutlinedIcon from "@mui/icons-material/TaskAltOutlined";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import BalanceIcon from "@mui/icons-material/Balance";
import {
  DataGrid,
  GridToolbarQuickFilter,
  GridToolbarContainer,
  GridToolbarExport,
} from "@mui/x-data-grid";
import { tokens, ColorModeContext } from "../../Theme";
import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import {
  fetchListview,
  isReasonOpen,
  leaveAppoval,
} from "../../store/reducers/Listviewapireducer";
import useMediaQuery from "@mui/material/useMediaQuery";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import { useProSidebar } from "react-pro-sidebar";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import PendingActionsIcon from "@mui/icons-material/PendingActions";
import PrintOutlinedIcon from "@mui/icons-material/PrintOutlined";
import DatasetLinkedIcon from '@mui/icons-material/DatasetLinked';
import { useContext } from "react";
// import MatxCustomizer from "./Mailpdf";
import SettingsBackupRestoreIcon from "@mui/icons-material/SettingsBackupRestore";
import {
  dataGridHeaderFooterHeight,
  dataGridHeight,
  dataGridRowHeight,
} from "../../ui-components/global/utils";
import CheckIcon from "@mui/icons-material/Check";
import ClearIcon from "@mui/icons-material/Clear";
import toast from "react-hot-toast";
import { Formik } from "formik";
import axios from "axios";
import PersonPinOutlinedIcon from "@mui/icons-material/PersonPinOutlined";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import MoreTimeOutlinedIcon from "@mui/icons-material/MoreTimeOutlined";
import FollowTheSignsOutlinedIcon from "@mui/icons-material/FollowTheSignsOutlined";
import WorkOutlinedIcon from "@mui/icons-material/WorkOutlined";
import ConnectWithoutContactIcon from "@mui/icons-material/ConnectWithoutContact";
import RequestQuoteOutlinedIcon from "@mui/icons-material/RequestQuoteOutlined";
import EuroSymbolIcon from "@mui/icons-material/EuroSymbol";
import ExplicitIcon from "@mui/icons-material/Explicit";
import AttributionIcon from "@mui/icons-material/Attribution";
import CoPresentIcon from "@mui/icons-material/CoPresent";
import GroupsIcon from "@mui/icons-material/Groups";
import ArtTrackIcon from "@mui/icons-material/ArtTrack";
import StreamIcon from "@mui/icons-material/Stream";
import TaskIcon from "@mui/icons-material/Task";
import VisibilityIcon from "@mui/icons-material/Visibility";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import EscalatorWarningIcon from "@mui/icons-material/EscalatorWarning";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import {
  FilterGetData,
  FilterPostData,
  setFilterGetData,
  VoiceApi,
} from "../../store/reducers/Formapireducer";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import {
  CheckinAutocomplete,
  Employeeautocomplete,
  MultiFormikOptimizedAutocomplete,
} from "../../ui-components/global/Autocomplete";
import { Download } from "@mui/icons-material";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import MicIcon from "@mui/icons-material/Mic";
import SearchIcon from "@mui/icons-material/Search";

import DashboardIcon from "@mui/icons-material/Dashboard";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import QuizIcon from "@mui/icons-material/Quiz";
import DashboardOutlinedIcon from "@mui/icons-material/DashboardOutlined";
import AnalyticsIcon from "@mui/icons-material/Analytics";
import CachedOutlinedIcon from "@mui/icons-material/CachedOutlined";
import CancelIcon from "@mui/icons-material/Cancel";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import { getConfig } from "../../config";
import { PDFDownloadLink } from "@react-pdf/renderer";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import OnsitesummaryPDF from "../reports/Summaryonsite";
import OHsummaryPDF from "../reports/Overheadsummary";
import ExpenseprjPDF from "../reports/Expenseprjbasedpdf";
import ExpenseOHPDF from "../reports/ExpenseOHbasedpdf";

import VerifiedOutlinedIcon from '@mui/icons-material/VerifiedOutlined';
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import LockResetOutlinedIcon from '@mui/icons-material/LockResetOutlined';
const ListviewSecondary = () => {
  const [currentDate, setCurrentDate] = useState(new Date());
  const [search, setSearch] = useState("");
  const [listening, setListening] = useState(false);
  const recognitionRef = useRef(null);
  // ✅ Load from session for TR263 if available
  // const filterData = savedFilters ? JSON.parse(savedFilters) : {};
  const filterGetData = useSelector((state) => state.formApi.filterGetData);
  const [showFilter, setShowFilter] = React.useState(false);
  const formattedDate2 = (date) => {
    if (!date) return "";
    const d = new Date(date);
    if (isNaN(d)) return "";
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();
    return `${day}-${month}-${year}`;
  };
  const HeaderImg = sessionStorage.getItem("CompanyHeader");
  const FooterImg = sessionStorage.getItem("CompanyFooter");

  const SubscriptionCode = sessionStorage.getItem("SubscriptionCode");
  const is003Subscription = SubscriptionCode.endsWith("003");
  console.log(SubscriptionCode, is003Subscription, "SubscriptionCode");


  const config = getConfig();
  const baseurl1 = config.UAAM_URL;
  console.log("HeaderImg", HeaderImg, FooterImg);

  const getMondayAndSaturday = (date) => {
    const dayOfWeek = date.getDay(); // 0 = Sunday, 1 = Monday, ..., 6 = Saturday

    // Calculate Monday (if Sunday, subtract 6 days; otherwise, subtract dayOfWeek - 1)
    const monday = new Date(date);
    monday.setDate(date.getDate() - (dayOfWeek === 0 ? 6 : dayOfWeek - 1));

    // Clone Monday to get Saturday
    const saturday = new Date(monday);
    saturday.setDate(monday.getDate() + 5);

    return { monday, saturday };
  };

  const formatDateShort = (date) => {
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");
    return `${month}/${day}`;
  };

  // Format a full date into MM/DD/YYYY format
  const formatDateLong = (date) => {
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");
    const year = date.getFullYear();
    return `${year}-${month}-${day}`;
  };

  const getWeekDates = () => {
    const date = new Date(currentDate);

    const { monday, saturday } = getMondayAndSaturday(date);
    return {
      monday: formatDateLong(monday),
      saturday: formatDateLong(saturday),
      shortMonday: formatDateShort(monday),
      shortSaturday: formatDateShort(saturday),
    };
  };
  const handleResetFilters = (setFieldValue) => {
    // 1. Remove saved filters
    sessionStorage.removeItem("TR263_Filters");

    // 2. Remove each field entry
    const keys = [
      "fromDate",
      "toDate",
      "self",
      "manager",
      "sprint",
      "assigned",
      "scheduled",
      "inprogress",
      "completed",
      "approved",
      "query",
      "project",
      "team",
      "lastDay",
      "TaskType",
    ];

    keys.forEach((key) => {
      sessionStorage.removeItem(`TR263_${key}`);
    });

    // 3. Clear Formik fields
    setFieldValue("fromDate", "");
    setFieldValue("toDate", "");
    setFieldValue("self", false);
    setFieldValue("manager", false);
    setFieldValue("sprint", false);
    setFieldValue("assigned", false);
    setFieldValue("scheduled", false);
    setFieldValue("inprogress", false);
    setFieldValue("completed", false);
    setFieldValue("approved", false);
    setFieldValue("query", false);
    setFieldValue("project", []);
    setFieldValue("team", []);
    setFieldValue("lastDay", "");
    // setFieldValue("TaskType", "");
    setFieldValue("TaskType", []);

    sessionStorage.setItem(
      "TR263_Filters",
      JSON.stringify({
        fromDate: "",
        toDate: "",
        self: false,
        manager: false,
        sprint: false,
        assigned: false,
        scheduled: false,
        inprogress: false,
        completed: false,
        approved: false,
        query: false,
        project: [],
        team: [],
        lastDay: "",
        TaskType: [],
      })
    );
  };

  const SchlhandleResetFilters = (setFieldValue) => {
    // 1. Remove saved filters
    sessionStorage.removeItem("TR353_Filters");

    // 2. Remove each field entry
    const keys = [
      "fromDate",
      "toDate",
      "Teacher",
      "assigned",
      "scheduled",
      "inprogress",
      "completed",
      "approved",
      "query",
      "project",
      "Milestone",
      "team",
      "lastDay",
      "TaskType",
    ];

    keys.forEach((key) => {
      sessionStorage.removeItem(`TR353_${key}`);
    });

    // 3. Clear Formik fields
    setFieldValue("fromDate", "");
    setFieldValue("toDate", "");
    setFieldValue("Teacher", false);
    setFieldValue("assigned", false);
    setFieldValue("scheduled", false);
    setFieldValue("inprogress", false);
    setFieldValue("completed", false);
    setFieldValue("approved", false);
    setFieldValue("query", false);
    setFieldValue("project", null);
    setFieldValue("Milestone", []);
    setFieldValue("team", []);
    setFieldValue("lastDay", "");
    // setFieldValue("TaskType", "");
    setFieldValue("TaskType", []);

    sessionStorage.setItem(
      "TR353_Filters",
      JSON.stringify({
        fromDate: "",
        toDate: "",
        Teacher: false,
        assigned: false,
        scheduled: false,
        inprogress: false,
        completed: false,
        approved: false,
        query: false,
        project: null,
        Milestone: [],
        team: [],
        lastDay: "",
        TaskType: [],
      })
    );
  };


  // const savedFiltersRaw = sessionStorage.getItem("TR353_Filters");
  // console.log(savedFiltersRaw, "--savedFiltersRaw");

  // const savedFilters = savedFiltersRaw ? JSON.parse(savedFiltersRaw) : {};
  // const savedFromDate = sessionStorage.getItem("TR353_fromDate");
  // const savedToDate = sessionStorage.getItem("TR353_toDate");

  // const savedTaskType = JSON.parse(
  //   sessionStorage.getItem("TR353_TaskType") || "[]",
  // );
  // console.log("Restored TaskType:", savedTaskType);

  // const sclsavedTaskType = JSON.parse(
  //   sessionStorage.getItem("TR353_TaskType") || "[]",
  // );
  // console.log("Restored sclsavedTaskType:", sclsavedTaskType);
    const [teamData, setmgrEpm] = React.useState(
    JSON.parse(sessionStorage.getItem("MangerEmpDetails")) || [],
  );
  console.log("🚀 ~ ListviewSecondary ~ teamData:", teamData)
  const savedFiltersRaw = sessionStorage.getItem("TR263_Filters");
  console.log(savedFiltersRaw, "--savedFiltersRaw");

  const savedFilters = savedFiltersRaw ? JSON.parse(savedFiltersRaw) : {};


  const savedSCLFiltersRaw = sessionStorage.getItem("TR353_Filters");
  console.log(savedSCLFiltersRaw, "--savedSCLFiltersRaw");

  const savedSCLFilters = savedSCLFiltersRaw ? JSON.parse(savedSCLFiltersRaw) : {};
  const savedFromDate = sessionStorage.getItem("TR263_fromDate");
  const savedToDate = sessionStorage.getItem("TR263_toDate");

  const savedSCLFromDate = sessionStorage.getItem("TR353_fromDate");
  const savedSCLToDate = sessionStorage.getItem("TR353_toDate");

  const savedTaskType = JSON.parse(
    sessionStorage.getItem("TR263_TaskType") || "[]",
  );
  console.log("Restored TaskType:", savedTaskType);

  const sclsavedTaskType = JSON.parse(
    sessionStorage.getItem("TR353_TaskType") || "[]",
  );
  console.log("Restored sclsavedTaskType:", sclsavedTaskType);
  const initialFilterValues = {
    // fromDate: savedFilters.fromDate || savedFromDate || filterGetData.fromDate || "",
    // toDate: savedFilters.toDate || savedToDate || filterGetData.toDate || "",
    fromDate: savedFilters?.fromDate || "",
    toDate: savedFilters?.toDate || "",
    self: savedFilters?.self === true || savedFilters?.self === "Y" || filterGetData.self || false,
    manager: savedFilters?.manager === true || savedFilters?.manager === "Y" || filterGetData.manager || false,
    sprint: savedFilters?.sprint === true || savedFilters?.sprint === "Y" || filterGetData.sprint || false,
    assigned: savedFilters?.assigned === true || savedFilters?.assigned === "Y" || filterGetData.assigned || false,
    scheduled: savedFilters?.scheduled === true || savedFilters?.scheduled === "Y" || filterGetData.scheduled || false,
    inprogress: savedFilters?.inprogress === true || savedFilters?.inprogress === "Y" || filterGetData.inprogress || false,
    completed: savedFilters?.completed === true || savedFilters?.completed === "Y" || filterGetData.completed || false,
    approved: savedFilters?.approved === true || savedFilters?.approved === "Y" || filterGetData.approved || false,
    query: savedFilters?.query === true || savedFilters?.query === "Y" || filterGetData.query || false,
    // team: savedFilters?.team?.length ? savedFilters?.team : filterGetData.team || [],
    team:
  savedFilters.team?.length > 0
    ? savedFilters.team
    :  [],
    project: savedFilters?.project?.length ? savedFilters?.project : filterGetData.project || [],
    lastDay: savedFilters?.lastDay || filterGetData.lastDay || 0,
    // TaskType: savedTaskType,
    TaskType: savedFilters?.TaskType || [],
  };

  const sclinitialFilterValues = {
    // fromDate:
    //   savedSCLFilters.fromDate || savedSCLFromDate || filterGetData.fromDate || "",
    // toDate: savedSCLFilters.toDate || savedSCLToDate || filterGetData.toDate || "",
    fromDate: savedSCLFilters?.fromDate || "",
    toDate: savedSCLFilters?.toDate || "",
    //  Teacher:
    //   savedSCLFilters.self === true ||
    //   savedSCLFilters.self === "Y" ||
    //   filterGetData.self ||
    //   false,
    // COMMENTED AS IT SHOULD BE savedSCLFilters.Teacher BEFORE IT WAS .self -- MANOJ
    Teacher:
      savedSCLFilters?.Teacher === true ||
      savedSCLFilters?.Teacher === "Y" ||
      filterGetData.Teacher ||
      false,
    self:
      savedSCLFilters?.self === true ||
      savedSCLFilters?.self === "Y" ||
      filterGetData.self ||
      false,
    manager:
      savedSCLFilters?.manager === true ||
      savedSCLFilters?.manager === "Y" ||
      filterGetData.manager ||
      false,
    sprint:
      savedSCLFilters?.sprint === true ||
      savedSCLFilters?.sprint === "Y" ||
      filterGetData.sprint ||
      false,
    assigned:
      savedSCLFilters?.assigned === true ||
      savedSCLFilters?.assigned === "Y" ||
      filterGetData.assigned ||
      false,
    scheduled:
      savedSCLFilters?.scheduled === true ||
      savedSCLFilters?.scheduled === "Y" ||
      filterGetData.scheduled ||
      false,
    inprogress:
      savedSCLFilters?.inprogress === true ||
      savedSCLFilters?.inprogress === "Y" ||
      filterGetData.inprogress ||
      false,
    completed:
      savedSCLFilters?.completed === true ||
      savedSCLFilters?.completed === "Y" ||
      filterGetData.completed ||
      false,
    approved:
      savedSCLFilters?.approved === true ||
      savedSCLFilters?.approved === "Y" ||
      filterGetData.approved ||
      false,
    query:
      savedSCLFilters.query === true ||
      savedSCLFilters.query === "Y" ||
      filterGetData.query ||
      false,
    // team: savedSCLFilters.team?.length
    //   ? savedSCLFilters.team
    //   : filterGetData.team || [],
      team:
  savedSCLFilters.team?.length > 0
    ? savedSCLFilters.team
    :  [],

    // project: savedSCLFilters.project?.length
    //   ? savedSCLFilters.project
    //   : filterGetData.project || [],
    project: savedSCLFilters?.project?.RecordID
      ? savedSCLFilters?.project?.RecordID
      : filterGetData.project?.RecordID || null,

    Milestone: savedSCLFilters?.Milestone?.length
      ? savedSCLFilters?.Milestone
      : filterGetData.Milestone || [],
    lastDay: savedSCLFilters?.lastDay || filterGetData.lastDay || 0,
    // TaskType: sclsavedTaskType,
    TaskType: savedSCLFilters?.TaskType || [],
  };

  const scltaskTypeOptions = [
    { value: "H", label: "Homework" },
    { value: "P", label: "Time Table" },
  ];

  const [errorMsgData, setErrorMsgData] = useState(null);
  useEffect(() => {
    if ("webkitSpeechRecognition" in window) {
      const SpeechRecognition = window.webkitSpeechRecognition;
      const recognition = new SpeechRecognition();
      recognition.continuous = false;
      recognition.interimResults = true;
      recognition.lang = "en-US";

      recognition.onresult = (event) => {
        let transcript = "";
        for (let i = event.resultIndex; i < event.results.length; i++) {
          transcript += event.results[i][0].transcript;
        }
        setSearch(transcript);
        console.log(transcript, "Search....");
      };

      recognition.onend = () => {
        setListening(false);
      };

      recognitionRef.current = recognition;
      console.log(recognition, "recognition....");
    }
  }, []);
  const currentDay = new Date().toISOString().split("T")[0];
  console.log("currentDay", currentDay);
  //Onsite Activities Filter
  const initialFilterValues2 = {
    projects: [],
    Employee: null,
    overheads: [],
    Status: "",
    fromdate: currentDay,
    todate: currentDay,
    Type: "ByProject",
  };
  // const savedFilters2 = sessionStorage.getItem("TR264_Filters");
  const savedFilters2 = sessionStorage.getItem("TR293_Filters");
  // const parsedFilters = savedFilters2
  //   ? JSON.parse(savedFilters2)
  //   : initialFilterValues2;
  const parsedFilters = savedFilters2
    ? JSON.parse(savedFilters2)
    : initialFilterValues2;

  useEffect(() => {
    fetch(process.env.PUBLIC_URL + "/validationcms.json")
      .then((res) => {
        if (!res.ok) throw new Error("Failed to fetch validationcms.json");
        return res.json();
      })
      .then((data) => {
        setErrorMsgData(data);
      })
      .catch((err) => console.error("Error loading validationcms.json:", err));
  }, []);
  const { shortMonday, shortSaturday, monday, saturday } = getWeekDates();
  const colorMode = useContext(ColorModeContext);
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const navigate = useNavigate();
  const location = useLocation();
  const state = location.state || {};
  console.log(state, "--state in Secondarylistview");

  const dispatch = useDispatch();
  const params = useParams();
  const year = sessionStorage.getItem("year");
  var secondaryCurrentPage = parseInt(
    sessionStorage.getItem("secondaryCurrentPage"),
  );
  var accessID = params.secondaryAccessID
    ? params.secondaryAccessID
    : params.accessID;
  const [pageSize, setPageSize] = React.useState(20);
  const [collapse, setcollapse] = React.useState(false);
  const [showMore, setShowMore] = React.useState(false);

  const [page, setPage] = React.useState(secondaryCurrentPage);

  const id = params.filtertype; // this comes from URL
  const { state: locationState = {} } = useLocation();

  const stagesID = id;
  // sessionStorage.setItem("ROUTE_ID", stagesID);
  sessionStorage.setItem("STAGES_ID", stagesID);

  console.log("milestoneID from state:", stagesID);

  var parentID = params.filtertype;
  console.log(parentID, "--parentID");

  var InvType = params.InvType;
  var Code = params.Code;
  var parentRecID = params.parentRecID;
  var CusID = params.CusID;
  var checkindate = params.Date;
  var checkindatehour = params.CheckInDate;
  const compID = sessionStorage.getItem("companyId");
  var screenName = params.screenName;
  console.log(screenName, "--screen Name in a SEcondary Listview");

  // var screenName_V1;

  // if (accessID === "TR233") {
  //   screenName_V1 = is003Subscription ? "Section" : params.screenName;
  // }

  // else {
  //   screenName_V1 = params.screenName;
  // }
  var Type = params.Type;
  var remarkDec = params.remarkDec;

  //SKILL GLOW
  let parentID1 = params.parentID1;
  let parentID2 = params.parentID2;
  let parentID3 = params.parentID3;
  let BreadCrumb1 = state.BreadCrumb1 || "";
  // console.log(parentID1, "---parentID1 filters in sec lidstview" );
  // console.log(parentID2, "---parentID2 filters in sec lidstview" );
  let BreadCrumb2 = state.BreadCrumb2 || "";
  let BreadCrumb3 = state.BreadCrumb3 || "";

  const { toggleSidebar, broken, rtl } = useProSidebar();
  const ManagerEmpIDCS = sessionStorage.getItem("ManagerEmpIDCS");
  const EMP_TRAINBY = sessionStorage.getItem("EMP_TRAINBY");
  const EMPID = sessionStorage.getItem("EmpId");
  console.log("🚀 ~ ListviewSecondary ~ EMPID:", EMPID)
  const MangerEmpID = JSON.parse(sessionStorage.getItem("MangerEmpID")) || [];
  const FirstLevelSub =
    JSON.parse(sessionStorage.getItem("FirstLevelSub")) || [];
  const rowData = location.state || {};
  var Description = params.Desc;
  var Number = params.Number;
  const listViewurl = useSelector((state) => state.globalurl.listViewurl);
  let filter;
  var invoiceFilter = `${parentID}' AND Invtype='${Number}'AND Finyear='${year}`;

  const listViewData = useSelector((state) => state.listviewApi.rowData);
  const open = useSelector((state) => state.listviewApi.mailOpen);
  const mailData = useSelector((state) => state.listviewApi.mailData);

  const loading = useSelector((state) => state.listviewApi.loading);
  const listViewcolumn = useSelector((state) => state.listviewApi.columnData);
  const isReasonOpened = useSelector((state) => state.listviewApi.isReasonOpen);
  const ReasonData = useSelector((state) => state.listviewApi.ReasonData);

  const handleMicClick = () => {
    const recognition = recognitionRef.current;
    if (!recognition) return;

    if (listening) {
      recognition.stop();
      setListening(false);
    } else {
      recognition.start();
      setListening(true);
    }
  };
  const [aiMode, setAiMode] = useState(false);

  // const handleSearch = async () => {
  //   if (!search.trim()) return;

  //   try {
  //     const data = await VoiceApi(search, compID, EMPID);
  //     console.log("AI API Response:", data);

  //     if (data.Status === "Y") {
  //       if (data?.filter?.Query?.Filter) {
  //         const queryData = data.filter.Query.Filter;
  //         dispatch(fetchListview(accessID, screenName, queryData, "", compID));
  //       }
  //     } else {
  //       toast.error(data.Message);
  //     }
  //   } catch (error) {
  //     console.error("API Error:", error);
  //     alert("Something went wrong while fetching data");
  //   }
  // };
  const handleSearch = async () => {
    if (!search.trim()) return;

    // enable AI mode
    setAiMode(true);

    try {
      const data = await VoiceApi(search, compID, EMPID);

      if (data.Status === "Y") {
        if (data?.filter?.Query?.Filter) {
          const queryData = data.filter.Query.Filter;
          dispatch(fetchListview(accessID, screenName, queryData, "", compID));
        }
      } else {
        toast.error(data.Message);
      }
    } catch (error) {
      console.error("API Error:", error);
      alert("Something went wrong while fetching data");
    }
  };

  const filterGetLoading = useSelector(
    (state) => state.formApi.filterGetLoading,
  );

  if (accessID == "TR087") {
    if (parentID == "A") {
      screenName = "Assorted";
    }
  }
  if (accessID == "TR011") {
    filter = invoiceFilter;
  } else if (accessID == "TR233") {
    filter = `CompanyID='${compID}' AND ProjectID='${parentID}'`;
    console.log(filter, "--calling TR233");
  } else if (accessID == "TR332") {
    filter = `EmployeeID = '${Number}' AND InvoiceHeaderID = '${parentID}'`;
  } else if (accessID == "TR236") {
    filter = `CompanyID='${compID}' AND MilestoneID='${parentID}'`;
    sessionStorage.getItem("MILESTONE_ID", parentID);
    console.log(filter, parentID, "--calling TR236");
  } else if (accessID == "TR234") {
    filter = `CompanyID='${compID}' AND OperationStageID='${parentID}'`;
    console.log(filter, "--calling TR234");
  } else if (accessID == "TR235") {
    filter = `CompanyID='${compID}' AND ActivitesID='${parentID}'`;
  } else if (accessID == "TR074") {
    filter = `${parentID}' AND Finyear='${year}`;
  } else if (accessID == "TR134") {
    filter = params.parentID;
  } else if (accessID == "TR112" || accessID == "TR112") {
    filter = `'${parentID}' AND Finyear='${year}'`;
  } else if (accessID == "TR047") {
    filter = `${parentID}' AND Finyear='${year}`;
  } else if (accessID == "TR115") {
    filter = `RemarkCode='${parentID}' AND Finyear='${year}'`;
  } else if (accessID == "TR052") {
    filter = `${parentID}' AND Finyear='${year}' AND RemarkRecordID='${parentRecID}`;
  } else if (accessID == "TR063") {
    filter = `Finyear='${year}'`;
  } else if (accessID == "TR284") {
    filter = `EmployeeID='${EMPID}' AND AssessmentID='${parentID1}'`;
  } else if (accessID == "TR290") {
    filter = `EmployeeID='${EMPID}' AND AssessmentType='${parentID1}'`;
  } else if (accessID == "TR352") {
    filter = `EmployeeID IN (${ManagerEmpIDCS}) AND (Status='Pass' OR Status='Appeared') AND AssessmentType='${parentID1}'`;
  } else if (accessID == "TR307") {
    filter = `EmployeeID='${EMPID}' AND AssessmentType='${parentID1}'`;
  }

  //   else if (accessID == "TR368") {
  //   filter = `CompanyID='${compID}' AND StandardID='${state.projectID}' AND Section='${state.MilestoneID}'`;
  // } 
  else if (accessID == "TR368") {
    filter = `CompanyID='${compID}' AND StandardID='${state.projectID || 0}'`;
  }

  else if (accessID == "TR289") {
    filter = `AssessmentID='${parentID1}'`;
  }
  // else if (accessID == "TR132") {
  //   // filter = `'${parentID}' AND CompanyID='${compID}'`;
  //   filter = `EmployeesID ='${EMPID}' AND DAILYTASKDATE='${
  //     params.Number || rowData.CheckInDate || rowData.DTCheckinDate
  //   }'`;
  // }
  else if (accessID == "TR132") {
    // filter = `'${parentID}' AND CompanyID='${compID}'`;
    filter = `EmployeesID ='${EMPID}' AND (DAILYTASKDATE='${params.Number || rowData.CheckInDate || rowData.DTCheckinDate
      }' OR STATUS='Inprogress')`;
  } else if (accessID == "TR263") {
    const savedSession =
      JSON.parse(sessionStorage.getItem("TR263_Filters")) || {};

    if (filterGetData || Object.keys(savedSession).length > 0) {
      // Merge session + new filter
      const fgd = { ...savedSession, ...filterGetData };

      const conditions = [];

      // DATE RANGE
      let fromDate = fgd?.fromDate;
      let toDate = fgd?.toDate;

      if (fromDate && toDate) {
        conditions.push(`HiddenDate BETWEEN '${fromDate}' AND '${toDate}'`);
      } else if (fgd.lastDay) {
        let { fromDate: f, currentDate } = getDateRange(fgd.lastDay);
        conditions.push(`HiddenDate BETWEEN '${f}' AND '${currentDate}'`);
      }
      else {
        conditions.push(`HiddenDate BETWEEN '${monday}' AND '${saturday}'`);
      }

      //  SOURCE FILTER
      const sourceFilters = [];
      if (fgd.self) sourceFilters.push(`'Self'`);
      if (fgd.manager) sourceFilters.push(`'Manager'`);
      if (fgd.sprint) sourceFilters.push(`'Sprint'`);

      if (sourceFilters.length > 0) {
        conditions.push(`FilterSource IN (${sourceFilters.join(", ")})`);
      }

      //  STATUS FILTERS
      const statusFilters = [];
      if (fgd.assigned) statusFilters.push(`'AS'`);
      if (fgd.scheduled) statusFilters.push(`'SH'`);
      if (fgd.inprogress) statusFilters.push(`'I'`);
      if (fgd.completed) statusFilters.push(`'C'`);
      if (fgd.approved) statusFilters.push(`'AP'`);
      if (fgd.query) statusFilters.push(`'RJ'`);

      if (statusFilters.length > 0) {
        conditions.push(`FilterStatus IN (${statusFilters.join(", ")})`);
      }

      //  AssignedBy Logic (corrected)
      if ((fgd.manager || fgd.sprint) && !fgd.self) {
        conditions.push(`AssignedBy IN (${EMPID})`);
      }

      if (fgd.manager && fgd.self) {
        conditions.push(`(AssignedBy IN (${EMPID}))`);
      }

      // COMPANY
      conditions.push(`CompanyID='${compID}'`);

      // TEAM LIST — made 100% safe
      // const teamList =
      //   Array.isArray(fgd?.team) && fgd.team.length > 0
      //     ? fgd.team
      //     : Array.isArray(FirstLevelSub)
      //       ? FirstLevelSub
      //       : [];
            const teamList =
  Array.isArray(fgd?.team) && fgd.team.length > 0
    ? fgd.team
    : Array.isArray(teamData)
      ? teamData.map((v) => v.ID)
      : [];

      filter =
        // `EmployeesID IN (${teamList.map((v) => `'${v}'`).join(",")}, '${EMPID}')` +
        `EmployeesID IN (${teamList.map((v) => `'${v.ID || v}'`).join(",")},'${EMPID}')` +
        ` AND ${conditions.join(" AND ")}`;

      // PROJECT FILTER
      if (Array.isArray(fgd?.project) && fgd.project.length > 0) {
        filter += ` AND ProjectID IN (${fgd.project
          .map((v) => `'${v.RecordID}'`)
          .join(",")})`;
      }
    }
  } else if (accessID == "TR353") {
    const savedSession =
      JSON.parse(sessionStorage.getItem("TR353_Filters")) || {};

    if (filterGetData || Object.keys(savedSession).length > 0) {
      // Merge session + new filter
      const fgd = { ...savedSession, ...filterGetData };

      const conditions = [];

      // DATE RANGE
      let fromDate = fgd?.fromDate;
      let toDate = fgd?.toDate;

      if (fromDate && toDate) {
        conditions.push(`HiddenDate BETWEEN '${fromDate}' AND '${toDate}'`);
      } else if (fgd.lastDay) {
        let { fromDate: f, currentDate } = getDateRange(fgd.lastDay);
        conditions.push(`HiddenDate BETWEEN '${f}' AND '${currentDate}'`);
      }
      else {
        conditions.push(`HiddenDate BETWEEN '${monday}' AND '${saturday}'`);
      }

      //  SOURCE FILTER
      const sourceFilters = [];
      if (fgd.Teacher) sourceFilters.push(`'Teacher'`);
      // if (fgd.self) sourceFilters.push(`'Self'`);
      // if (fgd.manager) sourceFilters.push(`'Manager'`);
      // if (fgd.sprint) sourceFilters.push(`'Sprint'`);

      if (sourceFilters.length > 0) {
        conditions.push(`FilterSource IN (${sourceFilters.join(", ")})`);
      }

      //  STATUS FILTERS
      const statusFilters = [];
      if (fgd.assigned) statusFilters.push(`'AS'`);
      if (fgd.scheduled) statusFilters.push(`'SH'`);
      if (fgd.inprogress) statusFilters.push(`'I'`);
      if (fgd.completed) statusFilters.push(`'C'`);
      if (fgd.approved) statusFilters.push(`'AP'`);
      if (fgd.query) statusFilters.push(`'RJ'`);

      if (statusFilters.length > 0) {
        conditions.push(`FilterStatus IN (${statusFilters.join(", ")})`);
      }

      //  AssignedBy Logic (corrected)
      if ((fgd.manager || fgd.sprint) && !fgd.self) {
        conditions.push(`AssignedBy IN (${EMPID})`);
      }

      if (fgd.manager && fgd.self) {
        conditions.push(`(AssignedBy IN (${EMPID}))`);
      }

      // COMPANY
      conditions.push(`CompanyID='${compID}'`);

      // TEAM LIST — made 100% safe
      // const teamList =
      //   Array.isArray(fgd?.team) && fgd.team.length > 0
      //     ? fgd.team
      //     : Array.isArray(FirstLevelSub)
      //       ? FirstLevelSub
      //       : [];
const teamList =
  Array.isArray(fgd?.team) && fgd.team.length > 0
    ? fgd.team
    : Array.isArray(teamData)
      ? teamData.map((v) => v.ID)
      : [];
      filter =
        // `EmployeesID IN (${teamList.map((v) => `'${v}'`).join(",")}, '${EMPID}')` +
        `EmployeesID IN (${teamList.map((v) => `'${v.ID || v}'`).join(",")},'${EMPID}')` +
        ` AND ${conditions.join(" AND ")}`;

      // PROJECT FILTER
      if (fgd?.project?.RecordID) {
        filter += ` AND ProjectID IN (${fgd.project.RecordID})`;
      }
      if (Array.isArray(fgd?.Milestone) && fgd.Milestone.length > 0) {
        filter += ` AND MilestoneID IN (${fgd.Milestone
          .map((v) => `'${v.RecordID}'`)
          .join(",")})`;
      }
    }
  } else if (accessID == "TR004") {
    filter = `parentID='${parentID}' AND STKType='${Number}'AND (Finyear='${year}' OR Finyear IS NULL)`;
  } else if (accessID == "TR084") {
    filter = `'${parentID}'`;
  } else if (accessID == "TR079") {
    filter = `${parentID}' AND '${Number}`;
  } else if (accessID == "TR097") {
    filter = `${parentID.slice(-1) == "I"
      ? "(DcType IN ('I','B'))"
      : parentID === "PO"
        ? "(DcType IN ('O','P'))"
        : "(DcType IN ('O','B'))"
      }`;
  } else if (accessID == "TR102") {
    filter = `InvType='${parentID}'`;
  } else if (accessID == "TR123") {
    filter = `CompanyID ='${compID}' AND EmployeeID='${params.filtertype}'`;
  } else if (accessID == "TR124") {
    filter = `EmployeeID='${params.filtertype}'`;
  } else if (
    accessID == "TR104" ||
    accessID == "TR113" ||
    accessID == "TR111"
  ) {
    filter = "";
  } else if (accessID == "TR105") {
    filter = `CustomerID ='${CusID}' AND InvType='${InvType}'`;
  } else if (accessID == "TR118") {
    filter = "";
  } else if (accessID == "TR051") {
    filter = `parentID='${parentID}' AND ${params.remarkDec === "L" ? "(Type IN ('L'))" : "(Type NOT IN ('L'))"
      }`;
  }
  // else if (accessID == "TR086") {
  //   // filter = `parentID ='${parentID}' AND Approvedby=${EMPID}`;
  //   filter = `CompanyID ='${compID}' AND Approvedby=${EMPID}`;
  //   //Employee Expense
  // }
  else if (accessID === "TR086") {
    // const storedFilters = sessionStorage.getItem("TR264_Filters");
    const storedFilters = sessionStorage.getItem("TR293_Filters");
    let filterCondition = "";
    const conditions = [];

    if (storedFilters) {
      const values = JSON.parse(storedFilters);
      if (values.fromdate && values.todate) {
        conditions.push(
          `FiDate BETWEEN '${values.fromdate}' AND '${values.todate}'`,
        );
      }
      if (values.status) {
        conditions.push(`AppStatus='${values.status}'`);
      }
      // if (values.Employee?.RecordID) {
      //   conditions.push(`EmployeeID IN (${values.Employee.RecordID})`);
      // }
      if (values.projects?.length > 0) {
        const projIds = values.projects.map((p) => `'${p.RecordID}'`).join(",");
        conditions.push(`ProjectID IN (${projIds})`);
      }
      if (values.overheads?.length > 0) {
        const OHIds = values.overheads.map((p) => `'${p.RecordID}'`).join(",");
        conditions.push(`OverheadRecordID IN (${OHIds})`);
      }
      conditions.push(`CompanyID='${compID}'`);
      conditions.push(`Approvedby='${EMPID}' AND type='H'`);

      filterCondition = conditions.join(" AND ");
    } else {
      filterCondition = `CompanyID='${compID}' AND Approvedby='${EMPID}' AND type = 'H'`;
    }
    filter = filterCondition;
  } else if (accessID == "TR255") {
    filter = `CompanyID ='${compID}' AND Approvedby ='${parentID}'`;
    //Salry Advance & Regularization
  } else if (accessID == "TR246") {
    filter = `CompanyID ='${compID}' AND parentID ='${parentID}'`;
  } else if (accessID == "TR247") {
    filter = `CompanyID ='${compID}' AND parentID ='${parentID}'`;
  } else if (accessID == "TR248") {
    // filter = `LA_APPEMID ='${EMPID}' ) AND parentID='${parentID}' AND CompanyID ='${compID}'`;
    filter = `LA_APPEMID ='${EMPID}' AND parentID='${parentID}' AND CompanyID ='${compID}'`;
    // filter = `parentID='${parentID}' AND CompanyID ='${compID}'`;

    //filter = `parentID='${parentID}'`;
    //Salry Advance & Regularization
  } else if (
    accessID == "TR254" ||
    accessID == "TR256" ||
    accessID == "TR267" ||
    accessID == "TR272"
  ) {
    filter = `CompanyID ='${compID}' AND EmployeeID ='${parentID}'`;
  } else {
    filter = parentID;
  }

  function filterByID(item) {
    if (item.hide !== true) {
      return true;
    }
  }

  // const columns = React.useMemo(
  //   () => listViewcolumn.filter(filterByID),
  //   [listViewcolumn]
  // );
  // const columnShow = React.useMemo(
  //   () =>
  //     listViewcolumn.filter(filterByID)
  //       ? [
  //         {
  //           field: "slno",
  //           headerName: "SL#",
  //           width: 50,
  //           sortable: false,
  //           filterable: false,
  //           valueGetter: (params) =>
  //             `${params.api.getRowIndexRelativeToVisibleRows(params.id) + 1}`,
  //         },
  //         ,
  //         ...listViewcolumn.filter(filterByID),
  //       ]
  //       : [],
  //   [listViewcolumn]
  // );
  const columnShow = React.useMemo(
    () =>
      listViewcolumn.filter(filterByID)
        ? [
          {
            field: "slno",
            headerName: "SL#",
            width: 50,
            sortable: false,
            filterable: false,
            valueGetter: (params) =>
              page * pageSize +
              params.api.getRowIndexRelativeToVisibleRows(params.id) +
              1,
          },
          ...listViewcolumn.filter(filterByID),
        ]
        : [],
    [listViewcolumn, page, pageSize], // include page & pageSize as deps
  );
  var apprval = "";
  var hderName = `Production Card(${params.Number})`;

  var to;
  var apprval = "";
  var screen;
  var invoice;

  // UOM
  if (accessID == "TR008") {
    screen = "UOM TYPE";
    to = "/Apps/TR049/UOM%20Type";
    if (parentID == "W") {
      apprval = "Weight";
    }
    if (parentID == "L") {
      apprval = "Length";
    }
    if (parentID == "C") {
      apprval = "Currency";
    }
    if (parentID == "V") {
      apprval = "Volume";
    }
    if (parentID == "S") {
      apprval = "Service";
    }
    if (parentID == "A") {
      apprval = "Area";
    }
  }

  if (accessID == "TR073") {
    to = "/Apps/TR043/Invoices";
    screen = "Invoices";
    if (parentID == "L") {
      apprval = "Leather-Export";
    }
    if (parentID == "P") {
      apprval = "Product-Export";
    }
    if (parentID == "M") {
      apprval = "Material";
    }
  }
  if (accessID == "TR084") {
    to = "/Apps/TR043/Invoices";
    screen = "Invoices";
    if (parentID == "LL") {
      apprval = "Leather-Domestic";
    }
    if (parentID == "PL") {
      apprval = "Product-Domestic";
    }
  }
  if (accessID == "TR011") {
    screen = "Invoices";
    if (parentID == "L") {
      apprval = "Leather-Export";
    }
    if (parentID == "P") {
      apprval = "Product-Export";
      to = `/Apps/Secondarylistview/TR073/Proforma%20Invoice/${parentID}`;
    }
    if (parentID == "M") {
      apprval = "Material";
    }
  }
  if (accessID == "TR011") {
    if (Number == "SI") {
      invoice = "Sample Invoice";
    }
    if (Number == "PI") {
      invoice = "Proforma Invoice";
    }
    if (Number == "FI") {
      invoice = "Final Invoice";
    }
  }
  if (accessID == "TR102") {
    if (parentID == "SI") {
      invoice = "Sample Invoice";
    }
    if (parentID == "PI") {
      invoice = "Proforma Invoice";
    }
    if (parentID == "FI") {
      invoice = "Final Invoice";
    }
  }
  if (accessID == "TR105") {
    if (InvType == "SI") {
      invoice = "Sample Invoice";
    }
    if (InvType == "PI") {
      invoice = "Proforma Invoice";
    }
    if (InvType == "FI") {
      invoice = "Final Invoice";
    }
  }
  if (accessID == "TR052" || accessID == "TR097") {
    screen = "Delivery Challan";
    to = "/Apps/TR059/Delivery%20Type";
    if (parentID == "LI") {
      apprval = "Leather In";
    }
    if (parentID == "LO") {
      apprval = "Leather Out";
    }
    if (parentID == "MI") {
      apprval = "Material In";
    }
    if (parentID == "MO") {
      apprval = "Material Out";
    }
    if (parentID == "PO") {
      apprval = "Product Out";
    }
  }
  var materialsecondType = "";

  if (accessID == "TR004") {
    screen = "Material Type";
    to = "/Apps/TR044/Materials%20Type";
    if (Number == "L") {
      apprval = "Leather";
      materialsecondType = "Material Type";
    }
    if (Number == "M") {
      apprval = "Material";
      materialsecondType = "Material Type";
    }
    if (Number == "S") {
      apprval = "Service";
      materialsecondType = "Material Type";
    }
    if (Number == "R") {
      apprval = "RF Material";
      materialsecondType = "Material Type";
    }
    if (Number == "P") {
      apprval = "Packing Material";
      materialsecondType = "Material Type";
    }
    if (Number == "LS") {
      apprval = "Sales-Leather";
      materialsecondType = "Material Type";
    }
  }

  if (accessID == "TR054") {
    screen = "Remarks";
    to = "/Apps/TR058/Remarks%20Type";
    if (parentID == "I") {
      apprval = "Delivery Chalan In";
    }
    if (parentID == "O") {
      apprval = "Delivery Chalan Out";
    }
    if (parentID == "P") {
      apprval = "Production Remarks";
    }
    if (parentID == "R") {
      apprval = "Returnable";
    }
    if (parentID == "N") {
      apprval = "Non-Returnable";
    }
  }
  var materialType = "";
  if (accessID == "TR003") {
    to = "/Apps/TR044/Materials Type";
    if (parentID == "L") {
      apprval = "Leather Type";
      materialType = "Material Type";
    }
    if (parentID == "M") {
      apprval = "Material";
      materialType = "Material Type";
    }
    if (parentID == "S") {
      apprval = "Service";
      materialType = "Material Type";
    }
    if (parentID == "R") {
      apprval = "RF Material";
      materialType = "Material Type";
    }
    if (parentID == "P") {
      apprval = "Packing Material";
      materialType = "Material Type";
    }
    if (parentID == "LS") {
      apprval = "Sales - Leather";
      materialType = "Material Type";
    }
  }

  if (accessID == "TR074" || accessID == "TR079") {
    to = "/Apps/TR076/Batches";
    if (parentID == "CC") {
      apprval = "Cutting Component";
    }
    if (parentID == "PC") {
      apprval = "Production";
    }
    if (parentID == "PK") {
      apprval = "Packing";
    }
  }
  if (accessID == "TR063") {
    to = "/Apps/TR064/Opening Stock";
    if (parentID == "M") {
      apprval = "Material";
    }
    if (parentID == "L") {
      apprval = "Leather";
    }
    if (parentID == "P") {
      apprval = "Product";
    }
  }
  var abbrevation = "";
  if (accessID == "TR079") {
    to = "/Apps/TR078/Stock Enquiry";
    if (parentID == "PC") {
      abbrevation = "Material ";
    }
    if (parentID == "CC") {
      abbrevation = "Leather";
    }
  }
  if (accessID == "TR080") {
    to = "/Apps/TR078/Stock Enquiry";
    if (Description == "PC") {
      abbrevation = "Material ";
    }
    if (Description == "CC") {
      abbrevation = "Leather";
    }
  }
  if (accessID == "TR032") {
    to = "/Apps/TR083/Colors";
    if (parentID == "M") {
      apprval = "Material";
    }
    if (parentID == "L") {
      apprval = "Leather";
    }
  }
  if (accessID == "TR138") {
    // to = `/Apps/Secondarylistview/TR137/Fixed%20Assets%20Category/${parentID}`;
    if (parentID == "M") {
      apprval = "Machinerys";
    }
    if (parentID == "T") {
      apprval = "Tools AND Vessles";
    }
    if (parentID == "MC") {
      apprval = "Miscellaneous";
    }
    if (parentID == "F") {
      apprval = "Fornutures";
    }
  }
  if (accessID == "TR086") {
    // to = `/Apps/Secondarylistview/TR137/Fixed%20Assets%20Category/${parentID}`;
    if (parentID == "P") {
      apprval = "Product";
    }
    if (parentID == "E") {
      apprval = "Employee";
    }
    if (parentID == "M") {
      apprval = "Material";
    }
    if (parentID == "F") {
      apprval = "Fixed Asset";
    }
  }
  if (accessID == "TR115") {
    to = "/Apps/TR078/Stock%20Enquiry";
    if (parentID == "R0001") {
      apprval = "(Purchase)";
    }
    if (parentID == "R0002") {
      apprval = "(Loan)";
    }
    if (parentID == "NR003") {
      apprval = "(Scrap)";
    }
    if (parentID == "R0003") {
      apprval = "(Job Work)";
    }
    if (parentID == "R0004") {
      apprval = "(Repair)";
    }
    if (parentID == "NR001") {
      apprval = "(Despatches)";
    }
    if (parentID == "NR002") {
      apprval = "(Compliments Or Samples)";
    }
  }
  if (accessID == "TR087") {
    to = "/Apps/TR078/Stock%20Enquiry";
    if (parentID == "N") {
      apprval = "Normal";
    }
    if (parentID == "A") {
      apprval = "Assorted";
    }
  }

  var openstackname = "Opening Stock";
  const fnLogOut = (props) => {
    Swal.fire({
      title: errorMsgData.Warningmsg[props],
      // text:data.payload.Msg,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: props,
    }).then((result) => {
      if (result.isConfirmed) {
        if (props === "Logout") {
          navigate("/");
        }
        if (props === "Close") {
          navigate("/Apps/TR027/Employees");
        }
      } else {
        return;
      }
    });
  };
  function CustomToolbar(listViewData) {
    function doesArrayContainNegative() {
      for (var arr of listViewData) {
        if (arr.Shortage < 0) return true;
      }
      return false;
    }
    return (
      <GridToolbarContainer
        sx={{
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          {accessID == "TR008" || accessID == "TR054" ? (
            <Box display="flex" borderRadius="3px" alignItems="center">
              <Breadcrumbs
                maxItems={2}
                aria-label="breadcrumb"
                separator={<NavigateNextIcon sx={{ color: "#0000D1" }} />}
              >
                <Typography
                  variant="h5"
                  color="#0000D1"
                  sx={{ cursor: "default" }}
                  onClick={() => {
                    navigate(to);
                  }}
                >
                  {screen}
                </Typography>

                <Typography
                  variant="h5"
                  color="#0000D1"
                  sx={{ cursor: "default" }}
                >
                  {apprval}
                </Typography>
              </Breadcrumbs>
            </Box>
          ) : accessID == "TR052" ? (
            <Box display="flex" borderRadius="3px" alignItems="center">
              <Breadcrumbs
                maxItems={2}
                aria-label="breadcrumb"
                separator={<NavigateNextIcon sx={{ color: "#0000D1" }} />}
              >
                <Typography
                  variant="h5"
                  color="#0000D1"
                  sx={{ cursor: "default" }}
                  onClick={() => {
                    navigate("/Apps/TR059/Delivery%20Type");
                  }}
                >
                  Delivery Type
                </Typography>
                <Typography
                  variant="h5"
                  color="#0000D1"
                  sx={{ cursor: "default" }}
                >
                  {apprval}
                </Typography>
                <Typography
                  variant="h5"
                  color="#0000D1"
                  sx={{ cursor: "default" }}
                  onClick={() => {
                    navigate(
                      `/Apps/Secondarylistview/TR097/Remarks/${params.filtertype}`,
                    );
                  }}
                >
                  Remarks({remarkDec})
                </Typography>
                {/* <Typography variant="h5" color="#0000D1" sx={{cursor:'default'}}  onClick={() => {navigate(to)}}>{screen}</Typography> */}
              </Breadcrumbs>
            </Box>
          ) : accessID == "TR073" ? (
            <Box display="flex" borderRadius="3px" alignItems="center">
              <Breadcrumbs
                maxItems={2}
                aria-label="breadcrumb"
                separator={<NavigateNextIcon sx={{ color: "#0000D1" }} />}
              >
                <Typography
                  variant="h5"
                  color="#0000D1"
                  sx={{ cursor: "default" }}
                  onClick={() => {
                    navigate(to);
                  }}
                >
                  {screen}
                </Typography>

                <Typography
                  variant="h5"
                  color="#0000D1"
                  sx={{ cursor: "default" }}
                  onClick={() => {
                    navigate(to);
                  }}
                >
                  {apprval}
                </Typography>
              </Breadcrumbs>
            </Box>
          ) : //SKILL GLOW - ASSESSMENT tYPE
            accessID == "TR290" ? (
              <Box display="flex" borderRadius="3px" alignItems="center">
                <Breadcrumbs
                  maxItems={2}
                  aria-label="breadcrumb"
                  separator={<NavigateNextIcon sx={{ color: "#0000D1" }} />}
                >
                  <Typography
                    variant="h5"
                    color="#0000D1"
                    sx={{ cursor: "default" }}
                    onClick={() => {
                      navigate("/Apps/TR308/List%20Of%20Assessment%20Type");
                    }}
                  >
                    List Of Assessment Type ({BreadCrumb1})
                  </Typography>

                  <Typography
                    variant="h5"
                    color="#0000D1"
                    sx={{ cursor: "default" }}
                  >
                    List Of Assessment
                  </Typography>
                </Breadcrumbs>
              </Box>
            ) : //TEAMS
              accessID == "TR368" ? (
                <Box display="flex" borderRadius="3px" alignItems="center">
                  <Breadcrumbs
                    maxItems={2}
                    aria-label="breadcrumb"
                    separator={<NavigateNextIcon sx={{ color: "#0000D1" }} />}
                  >
                    <Typography
                      variant="h5"
                      color="#0000D1"
                      sx={{ cursor: "default" }}
                      onClick={() => {
                        is003Subscription ?
                          navigate("/Apps/TR133/Classes") :
                          navigate("/Apps/TR133/Project");
                      }}
                    >
                      {is003Subscription ? `List Of Classes (${BreadCrumb1})` : `List Of Projects (${BreadCrumb1})`}
                    </Typography>

                    <Typography
                      variant="h5"
                      color="#0000D1"
                      sx={{ cursor: "default" }}
                    >
                      List Of Time Table
                    </Typography>
                  </Breadcrumbs>
                </Box>
              ) : //SKILL GLOW - ASSESSMENT tYPE
                accessID == "TR352" ? (
                  <Box display="flex" borderRadius="3px" alignItems="center">
                    <Breadcrumbs
                      maxItems={2}
                      aria-label="breadcrumb"
                      separator={<NavigateNextIcon sx={{ color: "#0000D1" }} />}
                    >
                      <Typography
                        variant="h5"
                        color="#0000D1"
                        sx={{ cursor: "default" }}
                        onClick={() => {
                          navigate("/Apps/TR308/List%20Of%20Assessment%20Type");
                        }}
                      >
                        List Of Assessment Type ({BreadCrumb1})
                      </Typography>

                      <Typography
                        variant="h5"
                        color="#0000D1"
                        sx={{ cursor: "default" }}
                      >
                        List Of Evaluation
                      </Typography>
                    </Breadcrumbs>
                  </Box>
                ) : //SKILL GLOW - APPRAISAL tYPE
                  accessID == "TR307" ? (
                    <Box display="flex" borderRadius="3px" alignItems="center">
                      <Breadcrumbs
                        maxItems={2}
                        aria-label="breadcrumb"
                        separator={<NavigateNextIcon sx={{ color: "#0000D1" }} />}
                      >
                        <Typography
                          variant="h5"
                          color="#0000D1"
                          sx={{ cursor: "default" }}
                          onClick={() => {
                            navigate("/Apps/TR308/List%20Of%20Assessment%20Type");
                          }}
                        >
                          List Of Assessment Type ({BreadCrumb1})
                        </Typography>

                        <Typography
                          variant="h5"
                          color="#0000D1"
                          sx={{ cursor: "default" }}
                        >
                          List Of Appraisal
                        </Typography>
                      </Breadcrumbs>
                    </Box>
                  ) : //SKILL GLOW - STORY BOARD
                    accessID == "TR284" ? (
                      <Box display="flex" borderRadius="3px" alignItems="center">
                        <Breadcrumbs
                          maxItems={2}
                          aria-label="breadcrumb"
                          separator={<NavigateNextIcon sx={{ color: "#0000D1" }} />}
                        >
                          <Typography
                            variant="h5"
                            color="#0000D1"
                            sx={{ cursor: "default" }}
                            onClick={() => {
                              navigate("/Apps/TR308/List%20Of%20Assessment%20Type");
                            }}
                          >
                            List Of Assessment Type({BreadCrumb1})
                          </Typography>
                          <Typography
                            variant="h5"
                            color="#0000D1"
                            sx={{ cursor: "default" }}
                            onClick={() => {
                              navigate(
                                `/Apps/Secondarylistview/skillglow/${params.accessID1}/${params.screenName}/${parentID3}`,
                                { state: { ...state } },
                              );
                            }}
                          >
                            List Of Assessment ({BreadCrumb2})
                          </Typography>

                          <Typography
                            variant="h5"
                            color="#0000D1"
                            sx={{ cursor: "default" }}
                          >
                            List Of Story Board
                          </Typography>
                        </Breadcrumbs>
                      </Box>
                    ) : //SKILL GLOW - SESSION
                      accessID == "TR289" ? (
                        <Box display="flex" borderRadius="3px" alignItems="center">
                          <Breadcrumbs
                            maxItems={2}
                            aria-label="breadcrumb"
                            separator={<NavigateNextIcon sx={{ color: "#0000D1" }} />}
                          >
                            <Typography
                              variant="h5"
                              color="#0000D1"
                              sx={{ cursor: "default" }}
                              onClick={() => {
                                navigate("/Apps/TR308/List%20Of%20Assessment%20Type");
                              }}
                            >
                              List Of Assessment Type({BreadCrumb1})
                            </Typography>
                            <Typography
                              variant="h5"
                              color="#0000D1"
                              sx={{ cursor: "default" }}
                              onClick={() => {
                                navigate(
                                  `/Apps/Secondarylistview/skillglow/${params.accessID1}/${params.screenName}/${parentID2}`,
                                  { state: { ...state } },
                                );
                              }}
                            >
                              List Of Assessment ({BreadCrumb2})
                            </Typography>
                            <Typography
                              variant="h5"
                              color="#0000D1"
                              sx={{ cursor: "default" }}
                            >
                              List Of Session
                            </Typography>
                          </Breadcrumbs>
                        </Box>
                      ) : accessID == "TR084" ? (
                        <Box display="flex" borderRadius="3px" alignItems="center">
                          <Breadcrumbs
                            maxItems={2}
                            aria-label="breadcrumb"
                            separator={<NavigateNextIcon sx={{ color: "#0000D1" }} />}
                          >
                            <Typography
                              variant="h5"
                              color="#0000D1"
                              sx={{ cursor: "default" }}
                              onClick={() => {
                                navigate(to);
                              }}
                            >
                              {screen}
                            </Typography>

                            <Typography
                              variant="h5"
                              color="#0000D1"
                              sx={{ cursor: "default" }}
                              onClick={() => {
                                navigate(to);
                              }}
                            >
                              {apprval}
                            </Typography>
                          </Breadcrumbs>
                        </Box>
                      ) : accessID == "TR011" ? (
                        <Box sx={{ display: "flex", flexDirection: "row" }}>
                          <Breadcrumbs
                            maxItems={2}
                            aria-label="breadcrumb"
                            separator={<NavigateNextIcon sx={{ color: "#0000D1" }} />}
                          >
                            <Typography
                              variant="h5"
                              color="#0000D1"
                              sx={{ cursor: "default" }}
                              onClick={() => {
                                navigate("/Apps/TR043/Invoices");
                              }}
                            >
                              {screen}
                            </Typography>
                            <Typography
                              variant="h5"
                              color="#0000D1"
                              sx={{ cursor: "default" }}
                              onClick={() => {
                                navigate(to);
                              }}
                            >
                              {apprval}
                            </Typography>

                            {Number !== "IN" && params.filtertype != "L" ? (
                              <Typography
                                variant="h5"
                                color="#0000D1"
                                sx={{ cursor: "default" }}
                              >
                                {invoice}
                              </Typography>
                            ) : (
                              false
                            )}
                          </Breadcrumbs>
                        </Box>
                      ) : accessID == "TR137" ? (
                        <Box sx={{ display: "flex", flexDirection: "row" }}>
                          <Breadcrumbs
                            maxItems={2}
                            aria-label="breadcrumb"
                            separator={<NavigateNextIcon sx={{ color: "#0000D1" }} />}
                          >
                            <Typography
                              variant="h5"
                              color="#0000D1"
                              sx={{ cursor: "default" }}
                              onClick={() => {
                                navigate("/Apps/TR135/Fixed%20Asset%20Type");
                              }}
                            >
                              Fixed Asset Type
                            </Typography>
                            <Typography
                              variant="h5"
                              color="#0000D1"
                              sx={{ cursor: "default" }}
                              onClick={() => {
                                navigate(to);
                              }}
                            >
                              Fixed Asset Category
                            </Typography>
                          </Breadcrumbs>
                        </Box>
                      ) : accessID == "TR270" ? (
                        <Breadcrumbs
                          maxItems={2}
                          aria-label="breadcrumb"
                          separator={<NavigateNextIcon sx={{ color: "#0000D1" }} />}
                        >
                          <Typography
                            key={8646}
                            variant="h5"
                            color="#0000D1"
                            sx={{ cursor: "default" }}
                            onClick={() => {
                              navigate("/Apps/TR276/Project");
                              //navigate(-1);
                            }}
                          >
                            {`Project(${state.ProjectName})`}
                          </Typography>

                          <Typography
                            key={63259}
                            variant="h5"
                            color="#0000D1"
                            sx={{ cursor: "default" }}
                          >
                            {screenName}
                          </Typography>
                        </Breadcrumbs>
                      ) : accessID == "TR233" ? (
                        <Breadcrumbs
                          maxItems={2}
                          aria-label="breadcrumb"
                          separator={<NavigateNextIcon sx={{ color: "#0000D1" }} />}
                        >
                          <Typography
                            key={8646}
                            variant="h5"
                            color="#0000D1"
                            sx={{ cursor: "default" }}
                            onClick={() => {
                              //navigate("/Apps/TR133/Project");
                              navigate(-1);
                            }}
                          >
                            {is003Subscription ? `Standard(${state.projectName})` : `Project(${state.projectName})`}
                          </Typography>

                          <Typography
                            key={63259}
                            variant="h5"
                            color="#0000D1"
                            sx={{ cursor: "default" }}
                          >
                            {screenName}
                          </Typography>
                        </Breadcrumbs>
                      ) : accessID == "TR332" ? (
                        <Breadcrumbs
                          maxItems={2}
                          aria-label="breadcrumb"
                          separator={<NavigateNextIcon sx={{ color: "#0000D1" }} />}
                        >
                          <Typography
                            key={8646}
                            variant="h5"
                            color="#0000D1"
                            sx={{ cursor: "default" }}
                            onClick={() => {
                              //navigate("/Apps/TR133/Project");
                              navigate(-1);
                            }}
                          >
                            {`Invoice(${state.Employee})`}
                          </Typography>

                          <Typography
                            key={63259}
                            variant="h5"
                            color="#0000D1"
                            sx={{ cursor: "default" }}
                          >
                            {screenName}
                          </Typography>
                        </Breadcrumbs>
                      ) : accessID == "TR236" ? (
                        <Breadcrumbs
                          maxItems={2}
                          aria-label="breadcrumb"
                          separator={<NavigateNextIcon sx={{ color: "#0000D1" }} />}
                        >
                          <Typography
                            key={85948}
                            variant="h5"
                            color="#0000D1"
                            sx={{ cursor: "default" }}
                            onClick={() => {
                              navigate("/Apps/TR133/Project");
                            }}
                          >
                            {`Project(${state.projectName})`}
                          </Typography>
                          <Typography
                            key={5968555646464}
                            variant="h5"
                            color="#0000D1"
                            sx={{ cursor: "default" }}
                            onClick={() => {
                              navigate(
                                `/Apps/Secondarylistview/TR233/Milestones/${state.projectID}`,
                                { state: { ...state } },
                              );
                              // navigate(-1);
                            }}
                          >
                            {`Milestones(${state.MilestoneName})`}
                          </Typography>

                          <Typography
                            key={9856235174435}
                            variant="h5"
                            color="#0000D1"
                            sx={{ cursor: "default" }}
                          >
                            {screenName}
                          </Typography>
                        </Breadcrumbs>
                      ) : accessID == "TR234" ? (
                        <Breadcrumbs
                          maxItems={2}
                          aria-label="breadcrumb"
                          separator={<NavigateNextIcon sx={{ color: "#0000D1" }} />}
                        >
                          <Typography
                            key={625895488949}
                            variant="h5"
                            color="#0000D1"
                            sx={{ cursor: "default" }}
                            onClick={() => {
                              navigate("/Apps/TR133/Project");
                            }}
                          >
                            {`Project(${state.projectName})`}
                          </Typography>
                          <Typography
                            key={6598332148}
                            variant="h5"
                            color="#0000D1"
                            sx={{ cursor: "default" }}
                            onClick={() => {
                              navigate(
                                `/Apps/Secondarylistview/TR233/Milestones/${state.projectID}`,
                                { state: { ...state } },
                              );
                            }}
                          >
                            {`Milestones(${state.MilestoneName})`}
                            {/* Milestone */}
                          </Typography>
                          <Typography
                            variant="h5"
                            color="#0000D1"
                            sx={{ cursor: "default" }}
                            onClick={() => {
                              navigate(
                                `/Apps/Secondarylistview/TR236/Stages/${state.MilestoneID}`,
                                { state: { ...state } },
                              );
                              // navigate(-1);
                            }}
                          >
                            {`Stages(${state.stagesName})`}
                          </Typography>

                          <Typography
                            variant="h5"
                            color="#0000D1"
                            sx={{ cursor: "default" }}
                          >
                            {screenName}
                          </Typography>
                        </Breadcrumbs>
                      ) : accessID == "TR235" ? (
                        <Breadcrumbs
                          maxItems={2}
                          aria-label="breadcrumb"
                          separator={<NavigateNextIcon sx={{ color: "#0000D1" }} />}
                        >
                          <Typography
                            key={586564984}
                            variant="h5"
                            color="#0000D1"
                            sx={{ cursor: "default" }}
                            onClick={() => {
                              navigate("/Apps/TR133/Project");
                            }}
                          >
                            {`Project(${state.projectName})`}
                          </Typography>
                          <Typography
                            key={846498493659}
                            variant="h5"
                            color="#0000D1"
                            sx={{ cursor: "default" }}
                            onClick={() => {
                              navigate(
                                `/Apps/Secondarylistview/TR233/Milestones/${state.projectID}`,
                                { state: { ...state } },
                              );
                            }}
                          >
                            {`Milestones(${state.MilestoneName})`}
                            {/* Milestone             */}
                          </Typography>
                          <Typography
                            key={66484999}
                            variant="h5"
                            color="#0000D1"
                            sx={{ cursor: "default" }}
                            onClick={() => {
                              navigate(
                                `/Apps/Secondarylistview/TR236/Stages/${state.MilestoneID}`,
                                { state: { ...state } },
                              );
                            }}
                          >
                            {`Stages(${state.stagesName})`}
                          </Typography>
                          <Typography
                            key={9943313844865649}
                            variant="h5"
                            color="#0000D1"
                            sx={{ cursor: "default" }}
                            onClick={() => {
                              navigate(
                                `/Apps/Secondarylistview/TR234/Activities/${state.OperationStageID}`,
                                { state: { ...state } },
                              );
                              // navigate(-1);
                            }}
                          >
                            {`Activities(${state.Activityname})`}
                          </Typography>

                          <Typography
                            key={789979897987984466}
                            variant="h5"
                            color="#0000D1"
                            sx={{ cursor: "default" }}
                          >
                            {screenName}
                          </Typography>
                        </Breadcrumbs>
                      ) : accessID == "TR138" ? (
                        <Box sx={{ display: "flex", flexDirection: "row" }}>
                          <Breadcrumbs
                            maxItems={2}
                            aria-label="breadcrumb"
                            separator={<NavigateNextIcon sx={{ color: "#0000D1" }} />}
                          >
                            <Typography
                              variant="h5"
                              color="#0000D1"
                              sx={{ cursor: "default" }}
                              onClick={() => {
                                navigate("/Apps/TR135/Fixed%20Asset%20Type");
                              }}
                            >
                              Fixed Asset Type
                            </Typography>
                            <Typography
                              variant="h5"
                              color="#0000D1"
                              sx={{ cursor: "default" }}
                              onClick={() => {
                                navigate(
                                  `/Apps/Secondarylistview/TR137/Fixed%20Assets%20Category/${params.Number}`,
                                );
                              }}
                            >
                              Fixed Asset Category
                            </Typography>
                            <Typography
                              variant="h5"
                              color="#0000D1"
                              sx={{ cursor: "default" }}
                              onClick={() => {
                                navigate(to);
                              }}
                            >
                              Fixed Asset
                            </Typography>
                          </Breadcrumbs>
                        </Box>
                      ) : accessID == "TR086" ? (
                        <Box sx={{ display: "flex", flexDirection: "row" }}>
                          <Breadcrumbs
                            maxItems={2}
                            aria-label="breadcrumb"
                            separator={<NavigateNextIcon sx={{ color: "#0000D1" }} />}
                          >
                            {/* <Typography
                variant="h5"
                color="#0c0c0cff"
                sx={{ cursor: "default" }}
                onClick={() => {
                  navigate("/Apps/TR027/Finance%20Category");
                }}
              >
                Expence Category
              </Typography> */}
                            <Typography
                              variant="h3"
                              color="#0c0c0cff"
                              sx={{ cursor: "default" }}
                            >
                              {is003Subscription ? "Expense" : "Expense Entry"}
                            </Typography>
                          </Breadcrumbs>
                        </Box>
                      ) : accessID == "TR102" ? (
                        <Box sx={{ display: "flex", flexDirection: "row" }}>
                          <Breadcrumbs
                            maxItems={2}
                            aria-label="breadcrumb"
                            separator={<NavigateNextIcon sx={{ color: "#0000D1" }} />}
                          >
                            <Typography
                              variant="h5"
                              color="#0000D1"
                              sx={{ cursor: "default" }}
                              onClick={() => {
                                navigate("/Apps/TR101/Order%20Enquiry");
                              }}
                            >
                              Order Enquiry
                            </Typography>
                            <Typography
                              variant="h5"
                              color="#0000D1"
                              sx={{ cursor: "default" }}
                            >
                              {invoice}
                            </Typography>
                          </Breadcrumbs>
                        </Box>
                      ) : accessID == "TR103" ? (
                        <Box sx={{ display: "flex", flexDirection: "row" }}>
                          <Breadcrumbs
                            maxItems={2}
                            aria-label="breadcrumb"
                            separator={<NavigateNextIcon sx={{ color: "#0000D1" }} />}
                          >
                            <Typography
                              variant="h5"
                              color="#0000D1"
                              sx={{ cursor: "default" }}
                              onClick={() => {
                                navigate("/Apps/TR101/Order%20Enquiry");
                              }}
                            >
                              Order Enquiry
                            </Typography>
                            <Typography
                              variant="h5"
                              color="#0000D1"
                              sx={{ cursor: "default" }}
                            >
                              Customer Group
                            </Typography>
                          </Breadcrumbs>
                        </Box>
                      ) : accessID == "TR104" ? (
                        <Box sx={{ display: "flex", flexDirection: "row" }}>
                          <Breadcrumbs
                            maxItems={2}
                            aria-label="breadcrumb"
                            separator={<NavigateNextIcon sx={{ color: "#0000D1" }} />}
                          >
                            <Typography
                              variant="h5"
                              color="#0000D1"
                              sx={{ cursor: "default" }}
                              onClick={() => {
                                navigate("/Apps/TR101/Order%20Enquiry");
                              }}
                            >
                              Order Enquiry
                            </Typography>
                            <Typography
                              variant="h5"
                              color="#0000D1"
                              sx={{ cursor: "default" }}
                              onClick={() => {
                                navigate("/Apps/Secondarylistview/TR103/Customergroup/5");
                              }}
                            >
                              {parentID}
                            </Typography>
                            <Typography
                              variant="h5"
                              color="#0000D1"
                              sx={{ cursor: "default" }}
                            >
                              Invoice Type
                            </Typography>
                          </Breadcrumbs>
                        </Box>
                      ) : accessID == "TR108" ? (
                        <Box sx={{ display: "flex", flexDirection: "row" }}>
                          <Breadcrumbs
                            maxItems={2}
                            aria-label="breadcrumb"
                            separator={<NavigateNextIcon sx={{ color: "#0000D1" }} />}
                          >
                            <Typography
                              variant="h5"
                              color="#0000D1"
                              sx={{ cursor: "default" }}
                              onClick={() => {
                                navigate("/Apps/TR047/Production%20Card");
                              }}
                            >
                              {hderName}
                            </Typography>
                            <Typography
                              variant="h5"
                              color="#0000D1"
                              sx={{ cursor: "default" }}
                            >
                              Production Card Item
                            </Typography>
                            <Typography
                              variant="h5"
                              color="#0000D1"
                              sx={{ cursor: "default" }}
                            >
                              {screenName}
                            </Typography>
                          </Breadcrumbs>
                        </Box>
                      ) : accessID == "TR105" ? (
                        <Box sx={{ display: "flex", flexDirection: "row" }}>
                          <Breadcrumbs
                            maxItems={2}
                            aria-label="breadcrumb"
                            separator={<NavigateNextIcon sx={{ color: "#0000D1" }} />}
                          >
                            <Typography
                              variant="h5"
                              color="#0000D1"
                              sx={{ cursor: "default" }}
                              onClick={() => {
                                navigate("/Apps/TR101/Order%20Enquiry");
                              }}
                            >
                              Order Tracking
                            </Typography>
                            <Typography
                              variant="h5"
                              color="#0000D1"
                              sx={{ cursor: "default" }}
                              onClick={() => {
                                navigate("/Apps/Secondarylistview/TR103/Customergroup/5");
                              }}
                            >
                              Customer Group
                            </Typography>
                            <Typography
                              variant="h5"
                              color="#0000D1"
                              sx={{ cursor: "default" }}
                              onClick={() => {
                                navigate(
                                  `/Apps/Secondarylistview/TR104/Invoicegroup/007/${CusID}`,
                                );
                              }}
                            >
                              Invoice Type
                            </Typography>
                            <Typography
                              variant="h5"
                              color="#0000D1"
                              sx={{ cursor: "default" }}
                            >
                              {invoice}
                            </Typography>
                          </Breadcrumbs>
                        </Box>
                      ) : accessID == "TR004" ? (
                        <Box sx={{ display: "flex", flexDirection: "row" }}>
                          <Breadcrumbs
                            maxItems={2}
                            aria-label="breadcrumb"
                            separator={<NavigateNextIcon sx={{ color: "#0000D1" }} />}
                          >
                            <Typography
                              variant="h5"
                              color="#0000D1"
                              sx={{ cursor: "default" }}
                              onClick={() => {
                                navigate(to);
                              }}
                            >
                              {materialsecondType}
                            </Typography>
                            <Typography
                              variant="h5"
                              color="#0000D1"
                              sx={{ cursor: "default" }}
                              onClick={() => {
                                navigate(
                                  `/Apps/Secondarylistview/TR003/Material%20Category/${Number}`,
                                );
                              }}
                            >
                              {apprval}
                            </Typography>
                            <Typography
                              variant="h5"
                              color="#0000D1"
                              sx={{ cursor: "default" }}
                              onClick={() => {
                                navigate(
                                  `/Apps/Secondarylistview/TR003/Material%20Category/${Number}`,
                                );
                              }}
                            >
                              {Description}
                            </Typography>
                            <Typography
                              variant="h5"
                              color="#0000D1"
                              sx={{ cursor: "default" }}
                            >{`List of ${apprval}`}</Typography>
                            {/* <Typography variant="h5" color="#0000D1" sx={{cursor:'default'}} >{invoice}</Typography>   */}
                          </Breadcrumbs>
                        </Box>
                      ) : accessID == "TR074" ? (
                        <Box sx={{ display: "flex", flexDirection: "row" }}>
                          <Breadcrumbs
                            maxItems={2}
                            aria-label="breadcrumb"
                            separator={<NavigateNextIcon sx={{ color: "#0000D1" }} />}
                          >
                            <Typography
                              variant="h5"
                              color="#0000D1"
                              sx={{ cursor: "default" }}
                              onClick={() => {
                                navigate(to);
                              }}
                            >
                              Batches
                            </Typography>

                            <Typography
                              variant="h5"
                              color="#0000D1"
                              sx={{ cursor: "default" }}
                              onClick={() => {
                                navigate(to);
                              }}
                            >
                              {apprval}
                            </Typography>
                          </Breadcrumbs>
                        </Box>
                      ) : accessID == "TR063" ? (
                        // <Box sx={{ display: "flex", flexDirection: "row" }}>
                        //   <Typography variant="h3" color="#0000D1" sx={{cursor:'pointer'}}  onClick={() => { navigate( `/Apps/TR064/Opening Stock` ); }}>{openstackname}</Typography>
                        //   <Typography variant="h3" color="#0000D1" >{screenName}</Typography>

                        // </Box>
                        <Box display="flex" borderRadius="3px" alignItems="center">
                          <Breadcrumbs
                            maxItems={2}
                            aria-label="breadcrumb"
                            separator={<NavigateNextIcon sx={{ color: "#0000D1" }} />}
                          >
                            <Typography
                              variant="h5"
                              color="#0000D1"
                              sx={{ cursor: "default" }}
                              onClick={() => {
                                navigate(`/Apps/TR064/Opening Stock`);
                              }}
                            >
                              {openstackname}
                            </Typography>
                            <Typography
                              variant="h5"
                              color="#0000D1"
                              sx={{ cursor: "default" }}
                              onClick={() => {
                                navigate(to);
                              }}
                            >
                              {apprval}
                            </Typography>
                            <Typography
                              variant="h5"
                              color="#0000D1"
                              sx={{ cursor: "default" }}
                            >
                              {screenName}
                            </Typography>
                          </Breadcrumbs>
                        </Box>
                      ) : accessID == "TR032" ? (
                        <Box display="flex" borderRadius="3px" alignItems="center">
                          <Breadcrumbs
                            maxItems={2}
                            aria-label="breadcrumb"
                            separator={<NavigateNextIcon sx={{ color: "#0000D1" }} />}
                          >
                            <Typography
                              variant="h5"
                              color="#0000D1"
                              sx={{ cursor: "default" }}
                              onClick={() => {
                                navigate(`/Apps/TR083/Colors - Material type`);
                              }}
                            >
                              Colors(MT)
                            </Typography>
                            <Typography
                              variant="h5"
                              color="#0000D1"
                              sx={{ cursor: "default" }}
                              onClick={() => {
                                navigate(to);
                              }}
                            >
                              {apprval}
                            </Typography>
                          </Breadcrumbs>
                        </Box>
                      ) : accessID == "TR033" ? (
                        <Box display="flex" borderRadius="3px" alignItems="center">
                          <Breadcrumbs
                            maxItems={2}
                            aria-label="breadcrumb"
                            separator={<NavigateNextIcon sx={{ color: "#0000D1" }} />}
                          >
                            <Typography
                              variant="h5"
                              color="#0000D1"
                              sx={{ cursor: "default" }}
                              onClick={() => {
                                navigate(`/Apps/TR083/Colors - Material type`);
                              }}
                            >
                              Colors(MT)
                            </Typography>
                            <Typography
                              variant="h5"
                              color="#0000D1"
                              sx={{ cursor: "default" }}
                              onClick={() => {
                                navigate("/Apps/Secondarylistview/TR032/Colors/L");
                              }}
                            >{`Leather(${params.Number})`}</Typography>
                            <Typography
                              variant="h5"
                              color="#0000D1"
                              sx={{ cursor: "default" }}
                            >
                              Color shades
                            </Typography>
                          </Breadcrumbs>
                        </Box>
                      ) : accessID == "TR117" ? (
                        <Box display="flex" borderRadius="3px" alignItems="center">
                          <Breadcrumbs
                            maxItems={2}
                            aria-label="breadcrumb"
                            separator={<NavigateNextIcon sx={{ color: "#0000D1" }} />}
                          >
                            <Typography
                              variant="h5"
                              color="#0000D1"
                              sx={{ cursor: "default" }}
                              onClick={() => {
                                navigate(`/Apps/TR083/Colors - Material type`);
                              }}
                            >
                              Colors(MT)
                            </Typography>
                            <Typography
                              variant="h5"
                              color="#0000D1"
                              sx={{ cursor: "default" }}
                              onClick={() => {
                                navigate("/Apps/Secondarylistview/TR032/Colors/L");
                              }}
                            >{`Leather(${params.Number})`}</Typography>
                            <Typography
                              variant="h5"
                              color="#0000D1"
                              sx={{ cursor: "default" }}
                            >{`Color Shades(${params.Desc})`}</Typography>
                          </Breadcrumbs>
                        </Box>
                      ) : accessID == "TR003" ? (
                        <Box sx={{ display: "flex", flexDirection: "row" }}>
                          <Breadcrumbs
                            maxItems={2}
                            aria-label="breadcrumb"
                            separator={<NavigateNextIcon sx={{ color: "#0000D1" }} />}
                          >
                            <Typography
                              variant="h5"
                              color="#0000D1"
                              sx={{ cursor: "default" }}
                              onClick={() => {
                                navigate(to);
                              }}
                            >
                              {materialType}
                            </Typography>
                            {/* <Typography variant="h5" color="#0000D1" sx={{cursor:'default'}} onClick={() => { navigate(to); }}>{apprval}</Typography> */}
                            {parentID == "L" || parentID == "LS" ? (
                              <Typography
                                variant="h5"
                                color="#0000D1"
                                sx={{ cursor: "default" }}
                              >
                                {apprval}
                              </Typography>
                            ) : (
                              ""
                            )}
                            {parentID == "M" || parentID == "S" ? (
                              <Typography
                                variant="h5"
                                color="#0000D1"
                                sx={{ cursor: "default" }}
                              >{`${apprval} Categories`}</Typography>
                            ) : (
                              ""
                            )}
                            {parentID == "R" || parentID == "P" ? (
                              <Typography
                                variant="h5"
                                color="#0000D1"
                                sx={{ cursor: "default" }}
                              >{`${apprval} Categories`}</Typography>
                            ) : (
                              ""
                            )}
                          </Breadcrumbs>
                        </Box>
                      ) : accessID == "TR021" ? (
                        <Box sx={{ display: "flex", flexDirection: "row" }}>
                          <Breadcrumbs
                            maxItems={2}
                            aria-label="breadcrumb"
                            separator={<NavigateNextIcon sx={{ color: "#0000D1" }} />}
                          >
                            <Typography
                              variant="h5"
                              color="#0000D1"
                              sx={{ cursor: "default" }}
                              onClick={() => {
                                navigate(`/Apps/TR072/Process%20Stage`);
                              }}
                            >
                              Process Stage
                            </Typography>
                            <Typography
                              variant="h5"
                              color="#0000D1"
                              sx={{ cursor: "default" }}
                              onClick={() => {
                                navigate(`/Apps/TR072/Process%20Stage`);
                              }}
                            >
                              {Number}
                            </Typography>
                            <Typography
                              variant="h5"
                              color="#0000D1"
                              sx={{ cursor: "default" }}
                            >
                              List Of Process
                            </Typography>
                          </Breadcrumbs>
                        </Box>
                      ) : accessID == "TR001" ? (
                        <Box sx={{ display: "flex", flexDirection: "row" }}>
                          <Breadcrumbs
                            maxItems={2}
                            aria-label="breadcrumb"
                            separator={<NavigateNextIcon sx={{ color: "#0000D1" }} />}
                          >
                            <Typography
                              variant="h5"
                              color="#0000D1"
                              sx={{ cursor: "default" }}
                              onClick={() => {
                                navigate(`/Apps/TR002/Categories`);
                              }}
                            >
                              {`Categories (${Number})`}
                            </Typography>
                            <Typography
                              variant="h5"
                              color="#0000D1"
                              sx={{ cursor: "default" }}
                            >
                              List of Products
                            </Typography>
                          </Breadcrumbs>
                        </Box>
                      ) : accessID == "TR048" ? (
                        <Breadcrumbs
                          maxItems={2}
                          aria-label="breadcrumb"
                          separator={<NavigateNextIcon sx={{ color: "#0000D1" }} />}
                        >
                          <Typography
                            variant="h5"
                            color="#0000D1"
                            sx={{ cursor: "default" }}
                            onClick={() => {
                              navigate(`/Apps/TR047/Production%20Card`);
                            }}
                          >
                            {" "}
                            {hderName}
                          </Typography>

                          <Typography
                            variant="h5"
                            color="#0000D1"
                            sx={{ cursor: "default" }}
                          >
                            {screenName}
                          </Typography>
                        </Breadcrumbs>
                      ) : accessID == "TR056" ? (
                        <Breadcrumbs
                          maxItems={2}
                          aria-label="breadcrumb"
                          separator={<NavigateNextIcon sx={{ color: "#0000D1" }} />}
                        >
                          <Typography
                            variant="h5"
                            color="#0000D1"
                            sx={{ cursor: "default" }}
                            onClick={() => {
                              navigate(`/Apps/TR047/Production%20Card`);
                            }}
                          >
                            {" "}
                            {hderName}
                          </Typography>
                          <Typography
                            variant="h5"
                            color="#0000D1"
                            sx={{ cursor: "default" }}
                            onClick={() => {
                              navigate("");
                            }}
                          >
                            Indent Items
                          </Typography>

                          <Typography
                            variant="h5"
                            color="#0000D1"
                            sx={{ cursor: "default" }}
                          >
                            {screenName}
                          </Typography>
                        </Breadcrumbs>
                      ) : accessID == "TR051" ? (
                        <Breadcrumbs
                          maxItems={2}
                          aria-label="breadcrumb"
                          separator={<NavigateNextIcon sx={{ color: "#0000D1" }} />}
                        >
                          <Typography
                            variant="h5"
                            color="#0000D1"
                            sx={{ cursor: "default" }}
                            onClick={() => {
                              navigate(`/Apps/TR047/Production%20Card`);
                            }}
                          >{`Production Card(${params.prdNumber})`}</Typography>
                          <Typography
                            variant="h5"
                            color="#0000D1"
                            sx={{ cursor: "default" }}
                            onClick={() => {
                              navigate(
                                `/Apps/Secondarylistview/TR118/Indent Type/${parentID}/${params.prdNumber}`,
                              );
                            }}
                          >
                            {params.remarkDec === "L" ? "Leather" : "Material"}
                          </Typography>
                          <Typography
                            variant="h5"
                            color="#0000D1"
                            sx={{ cursor: "default" }}
                          >
                            Indent Items
                          </Typography>
                        </Breadcrumbs>
                      ) : accessID == "TR118" ? (
                        <Breadcrumbs
                          maxItems={2}
                          aria-label="breadcrumb"
                          separator={<NavigateNextIcon sx={{ color: "#0000D1" }} />}
                        >
                          <Typography
                            variant="h5"
                            color="#0000D1"
                            sx={{ cursor: "default" }}
                            onClick={() => {
                              navigate(`/Apps/TR047/Production%20Card`);
                            }}
                          >
                            {" "}
                            {`Production Card(${params.Number})`}
                          </Typography>
                          <Typography
                            variant="h5"
                            color="#0000D1"
                            sx={{ cursor: "default" }}
                          >
                            Indent Type
                          </Typography>
                        </Breadcrumbs>
                      ) : accessID == "TR119" ? (
                        <Breadcrumbs
                          maxItems={2}
                          aria-label="breadcrumb"
                          separator={<NavigateNextIcon sx={{ color: "#0000D1" }} />}
                        >
                          <Typography
                            variant="h5"
                            color="#0000D1"
                            sx={{ cursor: "default" }}
                            onClick={() => {
                              navigate(`/Apps/TR047/Production%20Card`);
                            }}
                          >
                            {" "}
                            {`Production Card(${params.Number})`}
                          </Typography>
                          <Typography
                            variant="h5"
                            color="#0000D1"
                            sx={{ cursor: "default" }}
                          >
                            {params.Desc === "L" ? "Leather" : "Material"}
                          </Typography>
                          <Typography
                            variant="h5"
                            color="#0000D1"
                            sx={{ cursor: "default" }}
                          >
                            Indent Items
                          </Typography>
                          <Typography
                            variant="h5"
                            color="#0000D1"
                            sx={{ cursor: "default" }}
                          >
                            List of supplier
                          </Typography>
                        </Breadcrumbs>
                      ) : accessID == "TR050" ? (
                        <Breadcrumbs
                          maxItems={2}
                          aria-label="breadcrumb"
                          separator={<NavigateNextIcon sx={{ color: "#0000D1" }} />}
                        >
                          <Typography
                            variant="h5"
                            color="#0000D1"
                            sx={{ cursor: "default" }}
                            onClick={() => {
                              navigate("/Apps/TR002/Categories");
                            }}
                          >
                            {`Categories (${Number})`}
                          </Typography>
                          <Typography
                            variant="h5"
                            color="#0000D1"
                            sx={{ cursor: "default" }}
                            onClick={() => {
                              navigate(
                                `/Apps/Secondarylistview/TR001/Product%20Master/${params.bomproductid}/${Number}`,
                              );
                            }}
                          >
                            {Description}
                          </Typography>
                          <Typography
                            variant="h5"
                            color="#0000D1"
                            sx={{ cursor: "default" }}
                          >
                            {screenName}
                          </Typography>
                        </Breadcrumbs>
                      ) : accessID == "TR079" ? (
                        <Breadcrumbs
                          maxItems={2}
                          aria-label="breadcrumb"
                          separator={<NavigateNextIcon sx={{ color: "#0000D1" }} />}
                        >
                          <Typography
                            variant="h5"
                            color="#0000D1"
                            sx={{ cursor: "default" }}
                            onClick={() => {
                              navigate("/Apps/TR078/Stock%20Enquiry");
                            }}
                          >
                            Stock Enquiry
                          </Typography>
                          <Typography
                            variant="h5"
                            color="#0000D1"
                            sx={{ cursor: "default" }}
                          >
                            {abbrevation} Category
                          </Typography>
                          {/* <Typography variant="h5" color="#0000D1" sx={{cursor:'default'}} >{screenName}</Typography>
               */}
                        </Breadcrumbs>
                      ) : accessID == "TR080" ? (
                        <Breadcrumbs
                          maxItems={2}
                          aria-label="breadcrumb"
                          separator={<NavigateNextIcon sx={{ color: "#0000D1" }} />}
                        >
                          <Typography
                            variant="h5"
                            color="#0000D1"
                            sx={{ cursor: "default" }}
                            onClick={() => {
                              navigate("/Apps/TR078/Stock%20Enquiry");
                            }}
                          >
                            Stock Enquiry
                          </Typography>
                          <Typography
                            variant="h5"
                            color="#0000D1"
                            sx={{ cursor: "default" }}
                            onClick={() => {
                              navigate(
                                `/Apps/Secondarylistview/TR079/Material%20Category/${Description}`,
                              );
                            }}
                          >
                            {abbrevation} Category{" "}
                          </Typography>
                          {/* <Typography variant="h5" color="#0000D1" sx={{cursor:'default'}} >{screenName}</Typography> */}
                          <Typography
                            variant="h5"
                            color="#0000D1"
                            sx={{ cursor: "default" }}
                          >
                            {Number}
                          </Typography>
                        </Breadcrumbs>
                      ) : accessID == "TR111" ? (
                        <Breadcrumbs
                          maxItems={2}
                          aria-label="breadcrumb"
                          separator={<NavigateNextIcon sx={{ color: "#0000D1" }} />}
                        >
                          <Typography
                            variant="h5"
                            color="#0000D1"
                            sx={{ cursor: "default" }}
                            onClick={() => {
                              navigate("/Apps/TR078/Stock%20Enquiry");
                            }}
                          >
                            Stock Enquiry
                          </Typography>
                          <Typography
                            variant="h5"
                            color="#0000D1"
                            sx={{ cursor: "default" }}
                          >
                            List Of Supplier
                          </Typography>
                          {/* <Typography variant="h5" color="#0000D1" sx={{cursor:'default'}} >{screenName}</Typography> */}
                        </Breadcrumbs>
                      ) : accessID == "TR112" ? (
                        <Breadcrumbs
                          maxItems={2}
                          aria-label="breadcrumb"
                          separator={<NavigateNextIcon sx={{ color: "#0000D1" }} />}
                        >
                          <Typography
                            variant="h5"
                            color="#0000D1"
                            sx={{ cursor: "default" }}
                            onClick={() => {
                              navigate("/Apps/TR078/Stock%20Enquiry");
                            }}
                          >
                            Stock Enquiry
                          </Typography>
                          <Typography
                            variant="h5"
                            color="#0000D1"
                            sx={{ cursor: "default" }}
                            onClick={() => {
                              navigate(
                                "/Apps/Secondarylistview/TR111/List%20of%20Supplier/S/Supplier",
                              );
                            }}
                          >
                            List Of Supplier
                          </Typography>
                          {/* <Typography variant="h5" color="#0000D1" sx={{cursor:'default'}} >List Of Material</Typography> */}
                          <Typography
                            variant="h5"
                            color="#0000D1"
                            sx={{ cursor: "default" }}
                          >
                            {Number}
                          </Typography>
                        </Breadcrumbs>
                      ) : accessID == "TR113" ? (
                        <Breadcrumbs
                          maxItems={2}
                          aria-label="breadcrumb"
                          separator={<NavigateNextIcon sx={{ color: "#0000D1" }} />}
                        >
                          <Typography
                            variant="h5"
                            color="#0000D1"
                            sx={{ cursor: "default" }}
                            onClick={() => {
                              navigate("/Apps/TR078/Stock%20Enquiry");
                            }}
                          >
                            Stock Enquiry
                          </Typography>
                          <Typography
                            variant="h5"
                            color="#0000D1"
                            sx={{ cursor: "default" }}
                          >
                            List Of Production Card
                          </Typography>
                          {/* <Typography variant="h5" color="#0000D1" sx={{cursor:'default'}} >{screenName}</Typography>
               */}
                        </Breadcrumbs>
                      ) : accessID == "TR115" ? (
                        <Breadcrumbs
                          maxItems={2}
                          aria-label="breadcrumb"
                          separator={<NavigateNextIcon sx={{ color: "#0000D1" }} />}
                        >
                          <Typography
                            variant="h5"
                            color="#0000D1"
                            sx={{ cursor: "default" }}
                            onClick={() => {
                              navigate("/Apps/TR078/Stock%20Enquiry");
                            }}
                          >
                            Stock Enquiry
                          </Typography>
                          <Typography
                            variant="h5"
                            color="#0000D1"
                            sx={{ cursor: "default" }}
                          >
                            List Of Material{apprval}
                          </Typography>
                          {/* <Typography variant="h5" color="#0000D1" sx={{cursor:'default'}} >{screenName}</Typography>
               */}
                        </Breadcrumbs>
                      ) : accessID == "TR114" ? (
                        <Breadcrumbs
                          maxItems={2}
                          aria-label="breadcrumb"
                          separator={<NavigateNextIcon sx={{ color: "#0000D1" }} />}
                        >
                          <Typography
                            variant="h5"
                            color="#0000D1"
                            sx={{ cursor: "default" }}
                            onClick={() => {
                              navigate("/Apps/TR078/Stock%20Enquiry");
                            }}
                          >
                            Stock Enquiry
                          </Typography>
                          <Typography
                            variant="h5"
                            color="#0000D1"
                            sx={{ cursor: "default" }}
                            onClick={() => {
                              navigate(
                                "/Apps/Secondarylistview/TR113/List%20of%20ProductionCard/PD",
                              );
                            }}
                          >
                            List Of Production Card
                          </Typography>
                          <Typography
                            variant="h5"
                            color="#0000D1"
                            sx={{ cursor: "default" }}
                          >
                            Product Card Items
                          </Typography>
                          {/* <Typography variant="h5" color="#0000D1" sx={{cursor:'default'}} >{Number}</Typography> */}
                        </Breadcrumbs>
                      ) : accessID == "TR128" ? (
                        <Breadcrumbs
                          maxItems={2}
                          aria-label="breadcrumb"
                          separator={<NavigateNextIcon sx={{ color: "#0000D1" }} />}
                        >
                          <Typography
                            variant="h5"
                            color="#0000D1"
                            sx={{ cursor: "default" }}
                            onClick={() => {
                              navigate("/Apps/TR014/Company");
                            }}
                          >
                            Company
                          </Typography>
                          <Typography
                            variant="h5"
                            color="#0000D1"
                            sx={{ cursor: "default" }}
                          >
                            Location
                          </Typography>

                          {/* <Typography variant="h5" color="#0000D1" sx={{cursor:'default'}} >{screenName}</Typography>
               */}
                        </Breadcrumbs>
                      ) : accessID == "TR127" ? (
                        <Breadcrumbs
                          maxItems={2}
                          aria-label="breadcrumb"
                          separator={<NavigateNextIcon sx={{ color: "#0000D1" }} />}
                        >
                          <Typography
                            variant="h5"
                            color="#0000D1"
                            sx={{ cursor: "default" }}
                            onClick={() => {
                              navigate("/Apps/TR014/Company");
                            }}
                          >
                            Company
                          </Typography>
                          <Typography
                            variant="h5"
                            color="#0000D1"
                            sx={{ cursor: "default" }}
                            onClick={() => {
                              navigate(
                                `/Apps/Secondarylistview/TR128/Location/${params.Number}`,
                              );
                            }}
                          >
                            Location
                          </Typography>
                          <Typography
                            variant="h5"
                            color="#0000D1"
                            sx={{ cursor: "default" }}
                          >
                            Gate Entry
                          </Typography>
                          {/* <Typography variant="h5" color="#0000D1" sx={{cursor:'default'}} >{screenName}</Typography>
               */}
                        </Breadcrumbs>
                      ) : accessID == "TR245" ? (
                        <Breadcrumbs
                          maxItems={1}
                          aria-label="breadcrumb"
                          separator={<NavigateNextIcon sx={{ color: "#0000D1" }} />}
                        >
                          <Typography
                            variant="h3"
                            color="#0a0a0aff"
                          // sx={{ cursor: "default" }}
                          // onClick={() => {
                          //   navigate(`/Apps/Secondarylistview/TR245/Employees/${EMPID}`, {
                          //     state: rowData,
                          //   });

                          // navigate("/Apps/TR245/Employees", { state: rowData });
                          //}}
                          >
                            {/* {EMPID && rowData?.EmpLeaveOTOnduty
                  ? `Personnel(${rowData.EmpLeaveOTOnduty})`
                  : "Personnel"} */}
                            Personnel
                          </Typography>
                        </Breadcrumbs>
                      ) : accessID == "TR263" ? (
                        <Breadcrumbs
                        // maxItems={1}
                        // aria-label="breadcrumb"
                        // separator={<NavigateNextIcon sx={{ color: "#0000D1" }} />}
                        >
                          <Typography variant="h3" color="#0a0a0aff">
                            Tasks
                          </Typography>
                        </Breadcrumbs>
                      ) : accessID == "TR353" ? (
                        <Breadcrumbs>
                          <Typography variant="h3" color="#0a0a0aff">
                            Task Allocation
                          </Typography>
                        </Breadcrumbs>
                      ) : accessID == "TR248" ? (
                        <Breadcrumbs
                          maxItems={2}
                          aria-label="breadcrumb"
                          separator={<NavigateNextIcon sx={{ color: "#0000D1" }} />}
                        >
                          <Typography
                            variant="h5"
                            color="#0000D1"
                            sx={{ cursor: "default" }}
                            onClick={() => {
                              navigate(`/Apps/Secondarylistview/TR245/Employees/${EMPID}`, {
                                state: rowData,
                              });
                            }}
                          >
                            {/* {`Employees(${rowData.EmpLeaveOTOnduty})`} */}
                            {`Personnel(${rowData.EmpLeaveOTOnduty})`}
                          </Typography>
                          <Typography
                            variant="h5"
                            color="#0000D1"
                            sx={{ cursor: "default" }}
                          >
                            Leave Approval
                          </Typography>
                        </Breadcrumbs>
                      ) : accessID == "TR247" ? (
                        <Breadcrumbs
                          maxItems={2}
                          aria-label="breadcrumb"
                          separator={<NavigateNextIcon sx={{ color: "#0000D1" }} />}
                        >
                          <Typography
                            variant="h5"
                            color="#0000D1"
                            sx={{ cursor: "default" }}
                            onClick={() => {
                              navigate(`/Apps/Secondarylistview/TR245/Employees/${EMPID}`, {
                                state: rowData,
                              });
                            }}
                          >
                            {/* {`Employees(${rowData.EmpLeaveOTOnduty})`} */}
                            {`Personnel(${rowData.EmpLeaveOTOnduty})`}
                          </Typography>
                          <Typography
                            variant="h5"
                            color="#0000D1"
                            sx={{ cursor: "default" }}
                          >
                            Overtime Approval
                          </Typography>
                        </Breadcrumbs>
                      ) : accessID == "TR246" ? (
                        <Breadcrumbs
                          maxItems={2}
                          aria-label="breadcrumb"
                          separator={<NavigateNextIcon sx={{ color: "#0000D1" }} />}
                        >
                          <Typography
                            variant="h5"
                            color="#0000D1"
                            sx={{ cursor: "default" }}
                            onClick={() => {
                              navigate(`/Apps/Secondarylistview/TR245/Employees/${EMPID}`, {
                                state: rowData,
                              });
                            }}
                          >
                            {`Employees(${rowData.EmpLeaveOTOnduty})`}
                          </Typography>
                          <Typography
                            variant="h5"
                            color="#0000D1"
                            sx={{ cursor: "default" }}
                          >
                            On Duty Approval
                          </Typography>
                        </Breadcrumbs>
                      ) : accessID == "TR262" ? (
                        <Breadcrumbs
                          maxItems={1}
                          aria-label="breadcrumb"
                          separator={<NavigateNextIcon sx={{ color: "#0000D1" }} />}
                        >
                          <Typography
                            variant="h5"
                            color="#0000D1"
                            sx={{ cursor: "default" }}
                          >
                            {screenName}
                          </Typography>
                        </Breadcrumbs>
                      ) : accessID == "TR267" ? (
                        <Breadcrumbs
                          maxItems={2}
                          aria-label="breadcrumb"
                          separator={<NavigateNextIcon sx={{ color: "#0000D1" }} />}
                        >
                          <Typography
                            variant="h5"
                            color="#0000D1"
                            sx={{ cursor: "default" }}
                            onClick={() => {
                              navigate(`/Apps/Secondarylistview/TR245/Employees/${EMPID}`, {
                                state: rowData,
                              });
                            }}
                          >
                            {`Personnel(${rowData.EmpLeaveOTOnduty})`}
                          </Typography>
                          <Typography
                            variant="h5"
                            color="#0000D1"
                            sx={{ cursor: "default" }}
                          >
                            Permission Approval
                          </Typography>
                        </Breadcrumbs>
                      ) : accessID == "TR272" ? (
                        <Breadcrumbs
                          maxItems={2}
                          aria-label="breadcrumb"
                          separator={<NavigateNextIcon sx={{ color: "#0000D1" }} />}
                        >
                          <Typography
                            variant="h5"
                            color="#0000D1"
                            sx={{ cursor: "default" }}
                            onClick={() => {
                              navigate(`/Apps/Secondarylistview/TR245/Employees/${EMPID}`, {
                                state: rowData,
                              });
                            }}
                          >
                            {`Employees(${rowData.EmpLeaveOTOnduty})`}
                          </Typography>
                          <Typography
                            variant="h5"
                            color="#0000D1"
                            sx={{ cursor: "default" }}
                          >
                            Query Approval
                          </Typography>
                        </Breadcrumbs>
                      ) : accessID == "TR255" ? (
                        <Breadcrumbs
                          maxItems={2}
                          aria-label="breadcrumb"
                          separator={<NavigateNextIcon sx={{ color: "#0000D1" }} />}
                        >
                          <Typography
                            variant="h5"
                            color="#0000D1"
                            sx={{ cursor: "default" }}
                            onClick={() => {
                              navigate(`/Apps/Secondarylistview/TR245/Employees/${EMPID}`, {
                                state: rowData,
                              });
                            }}
                          >
                            {/* {`Employees(${rowData.EmpLeaveOTOnduty})`} */}
                            {`Personnel(${rowData.EmpLeaveOTOnduty})`}
                          </Typography>
                          <Typography
                            variant="h5"
                            color="#0000D1"
                            sx={{ cursor: "default" }}
                          >
                            Expense Entry
                          </Typography>
                        </Breadcrumbs>
                      ) : accessID == "TR254" ? (
                        <Breadcrumbs
                          maxItems={2}
                          aria-label="breadcrumb"
                          separator={<NavigateNextIcon sx={{ color: "#0000D1" }} />}
                        >
                          <Typography
                            variant="h5"
                            color="#0000D1"
                            sx={{ cursor: "default" }}
                            onClick={() => {
                              navigate(`/Apps/Secondarylistview/TR245/Employees/${EMPID}`, {
                                state: rowData,
                              });
                            }}
                          >
                            {/* {`Employees(${rowData.EmpLeaveOTOnduty})`} */}
                            {`Personnel(${rowData.EmpLeaveOTOnduty})`}
                          </Typography>
                          <Typography
                            variant="h5"
                            color="#0000D1"
                            sx={{ cursor: "default" }}
                          >
                            Salary Advance
                          </Typography>
                        </Breadcrumbs>
                      ) : accessID == "TR267" ? (
                        <Breadcrumbs
                          maxItems={2}
                          aria-label="breadcrumb"
                          separator={<NavigateNextIcon sx={{ color: "#0000D1" }} />}
                        >
                          <Typography
                            variant="h5"
                            color="#0000D1"
                            sx={{ cursor: "default" }}
                            onClick={() => {
                              navigate(`/Apps/Secondarylistview/TR267/Employees/${EMPID}`, {
                                state: rowData,
                              });
                            }}
                          >
                            {`Employees(${rowData.EmpLeaveOTOnduty})`}
                          </Typography>
                          <Typography
                            variant="h5"
                            color="#0000D1"
                            sx={{ cursor: "default" }}
                          >
                            Permission
                          </Typography>
                        </Breadcrumbs>
                      ) : accessID == "TR256" ? (
                        <Breadcrumbs
                          maxItems={2}
                          aria-label="breadcrumb"
                          separator={<NavigateNextIcon sx={{ color: "#0000D1" }} />}
                        >
                          <Typography
                            variant="h5"
                            color="#0000D1"
                            sx={{ cursor: "default" }}
                            onClick={() => {
                              navigate(`/Apps/Secondarylistview/TR245/Employees/${EMPID}`, {
                                state: rowData,
                              });
                            }}
                          >
                            {/* {`Employees(${rowData.EmpLeaveOTOnduty})`} */}
                            {`Personnel(${rowData.EmpLeaveOTOnduty})`}
                          </Typography>
                          <Typography
                            variant="h5"
                            color="#0000D1"
                            sx={{ cursor: "default" }}
                          >
                            Regularization
                          </Typography>
                        </Breadcrumbs>
                      ) : accessID == "TR129" ? (
                        <Breadcrumbs
                          maxItems={2}
                          aria-label="breadcrumb"
                          separator={<NavigateNextIcon sx={{ color: "#0000D1" }} />}
                        >
                          <Typography
                            variant="h5"
                            color="#0000D1"
                            sx={{ cursor: "default" }}
                            onClick={() => {
                              navigate("/Apps/TR014/Company");
                            }}
                          >
                            Company
                          </Typography>
                          <Typography
                            variant="h5"
                            color="#0000D1"
                            sx={{ cursor: "default" }}
                            onClick={() => {
                              navigate(
                                `/Apps/Secondarylistview/TR128/Location/${params.Number}`,
                              );
                            }}
                          >
                            Location
                          </Typography>
                          <Typography
                            variant="h5"
                            color="#0000D1"
                            sx={{ cursor: "default" }}
                          >
                            Bin
                          </Typography>
                          {/* <Typography variant="h5" color="#0000D1" sx={{cursor:'default'}} >{screenName}</Typography>
               */}
                        </Breadcrumbs>
                      ) : accessID == "TR097" ? (
                        <Breadcrumbs
                          maxItems={2}
                          aria-label="breadcrumb"
                          separator={<NavigateNextIcon sx={{ color: "#0000D1" }} />}
                        >
                          <Typography
                            variant="h5"
                            color="#0000D1"
                            sx={{ cursor: "default" }}
                            onClick={() => {
                              navigate("/Apps/TR059/Delivery%20Type");
                            }}
                          >
                            Delivery Type
                          </Typography>
                          <Typography
                            variant="h5"
                            color="#0000D1"
                            sx={{ cursor: "default" }}
                          >
                            {apprval}
                          </Typography>
                          <Typography
                            variant="h5"
                            color="#0000D1"
                            sx={{ cursor: "default" }}
                          >
                            {screenName}
                          </Typography>
                        </Breadcrumbs>
                      ) : accessID == "TR132" ? (
                        <Breadcrumbs
                          maxItems={2}
                          aria-label="breadcrumb"
                          separator={<NavigateNextIcon sx={{ color: "#0000D1" }} />}
                        >
                          <Typography
                            variant="h5"
                            color="#0000D1"
                            sx={{ cursor: "default" }}
                            onClick={() => {
                              navigate("/Apps/TR123/Check%20In", { state: rowData });
                            }}
                          >
                            {`Check In(${rowData.EmpDTName})`}
                          </Typography>

                          <Typography
                            variant="h5"
                            color="#0000D1"
                            sx={{ cursor: "default" }}
                          >
                            {screenName}
                          </Typography>

                          {/* <Typography variant="h5" color="#0000D1" sx={{ cursor: "default" }}>
      {checkindate}
    </Typography> */}
                        </Breadcrumbs>
                      ) : accessID == "TR134" ? (
                        <Breadcrumbs
                          maxItems={2}
                          aria-label="breadcrumb"
                          separator={<NavigateNextIcon sx={{ color: "#0000D1" }} />}
                        >
                          <Typography
                            variant="h5"
                            color="#0000D1"
                            sx={{ cursor: "default" }}
                            onClick={() => {
                              navigate("/Apps/TR123/Check%20In", { state: rowData });
                            }}
                          >
                            {`Check In(${rowData.EmpDTName})`}
                          </Typography>
                          <Typography
                            variant="h5"
                            color="#0000D1"
                            sx={{ cursor: "default" }}
                            onClick={() => {
                              navigate(
                                `/Apps/Secondarylistview/TR132/ScrumTask/${params.filtertype}/${params.Date}`,
                                { state: rowData },
                              );
                            }}
                          >
                            {`Daily Task(${rowData.DTCheckinDate})`}
                          </Typography>
                          <Typography
                            variant="h5"
                            color="#0000D1"
                            sx={{ cursor: "default" }}
                          >
                            {screenName}
                          </Typography>
                          {/* <Typography variant="h5" color="#0000D1" sx={{ cursor: "default" }}>
              {checkindate}
            </Typography> */}
                        </Breadcrumbs>
                      ) : accessID == "TR095" ? (
                        <Breadcrumbs
                          maxItems={2}
                          aria-label="breadcrumb"
                          separator={<NavigateNextIcon sx={{ color: "#0000D1" }} />}
                        >
                          <Typography
                            variant="h5"
                            color="#0000D1"
                            sx={{ cursor: "default" }}
                            onClick={() => {
                              navigate("/Apps/TR099/Companies");
                            }}
                          >
                            Companies
                          </Typography>
                          <Typography
                            variant="h5"
                            color="#0000D1"
                            sx={{ cursor: "default" }}
                          >
                            User Groups
                          </Typography>
                        </Breadcrumbs>
                      ) : (
                        <Box sx={{ display: "flex", flexDirection: "row" }}>
                          <Typography variant="h3" color="#0000D1">
                            {screenName}
                          </Typography>
                        </Box>
                      )}
          <Box justifyContent="end" display="flex">
            {broken && !rtl && (
              <IconButton onClick={() => toggleSidebar()}>
                <MenuOutlinedIcon />
              </IconButton>
            )}
            {accessID == "TR263" ? (
              <IconButton onClick={() => setShowMore((prev) => !prev)}>
                {showMore ? (
                  <Tooltip title="Close">
                    <FilterAltOutlinedIcon />
                  </Tooltip>
                ) : (
                  <Tooltip title="Open">
                    <FilterAltOutlinedIcon />
                  </Tooltip>
                )}
              </IconButton>
            ) : (
              false
            )}
            {accessID == "TR353" ? (
              <IconButton onClick={() => setShowMore((prev) => !prev)}>
                {showMore ? (
                  <Tooltip title="Close">
                    <FilterAltOutlinedIcon />
                  </Tooltip>
                ) : (
                  <Tooltip title="Open">
                    <FilterAltOutlinedIcon />
                  </Tooltip>
                )}
              </IconButton>
            ) : (
              false
            )}
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              {accessID === "TR086" ? (
                <IconButton onClick={() => setShowFilter((prev) => !prev)}>
                  {showFilter ? (
                    <Tooltip title="Close">
                      <FilterAltOutlinedIcon />
                    </Tooltip>
                  ) : (
                    <Tooltip title="Open">
                      <FilterAltOutlinedIcon />
                    </Tooltip>
                  )}
                </IconButton>
              ) : (
                false
              )}
              {/* Need to uncomment feature */}
              {/* {accessID !== "TR263" && <GridToolbarQuickFilter />} */}

              {/* {accessID == "TR263" && <GridToolbarQuickFilter />} */}

              {/* {accessID === "TR263" && (
                <IconButton size="small">
                  <Tooltip title="Speak">
                    <MicIcon />
                  </Tooltip>
                </IconButton>
              )} */}

              {/* Need to uncomment feature */}

              {accessID === "TR263" || accessID === "TR353" ? (
                <>
                  {/* AI MODE UI */}
                  {aiMode ? (
                    <>
                      <TextField
                        fullWidth
                        variant="standard"
                        placeholder="AI Assistant..."
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                        autoFocus
                        sx={{ width: "400px" }}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <Tooltip title="Search">
                                <IconButton onClick={handleSearch}>
                                  <SearchIcon />
                                </IconButton>
                              </Tooltip>
                            </InputAdornment>
                          ),
                        }}
                      />

                      {/* CANCEL ICON TO RETURN BACK TO NORMAL SEARCH */}
                      <Tooltip title="Close AI Search">
                        <IconButton
                          onClick={() => {
                            setAiMode(false);
                            setSearch(""); // optional: clear field
                          }}
                        >
                          <CancelIcon color="error" />
                        </IconButton>
                      </Tooltip>
                    </>
                  ) : (
                    <>
                      {/* NORMAL MODE SEARCH */}
                      <GridToolbarQuickFilter />

                      {/* MIC ICON TO ENTER AI MODE */}
                      <Tooltip title={listening ? "Listening..." : "Speak"}>
                        <IconButton
                          onClick={() => {
                            setAiMode(true); // enable AI mode
                            handleMicClick(); // mic logic
                          }}
                        >
                          <MicIcon color={listening ? "primary" : "action"} />
                        </IconButton>
                      </Tooltip>
                    </>
                  )}
                </>
              ) : (
                <GridToolbarQuickFilter />
              )}
            </Box>

            {accessID == "TR048" ? (
              false
            ) : accessID == "TR051" ? (
              false
            ) : accessID == "TR073" ? (
              false
            ) : accessID == "TR063" ? (
              false
            ) : accessID == "TR054" ? (
              false
            ) : accessID == "TR079" ? (
              false
            ) : accessID == "TR080" ? (
              false
            ) : accessID == "TR097" ? (
              false
            ) : accessID == "TR102" ? (
              false
            ) : accessID == "TR103" ? (
              false
            ) : accessID == "TR104" ? (
              false
            ) : accessID == "TR105" ? (
              false
            ) : accessID == "TR111" ? (
              false
            ) : accessID == "TR112" ? (
              false
            ) : accessID == "TR113" ? (
              false
            ) : accessID == "TR246" ? (
              false
            ) : accessID == "TR256" ? (
              false
            ) : accessID == "TR255" ? (
              false
            ) : accessID == "TR254" ? (
              false
            ) : accessID == "TR247" ? (
              false
            ) : accessID == "TR267" ? (
              false
            ) : accessID == "TR272" ? (
              false
            ) : accessID == "TR248" ? (
              false
            ) : accessID == "TR245" ? (
              false
            ) : accessID == "TR114" ? (
              false
            ) : accessID == "TR290" ? (
              false
            ) : accessID == "TR352" ? (
              false
            ) : accessID == "TR307" ? (
              false
            ) : accessID == "TR115" ? (
              false
            ) : accessID == "TR289" ? (
              false
            ) : accessID == "TR368" ? (
              false
            ) : accessID == "TR003" ? (
              <Tooltip arrow title="Stock Order">
                <AssessmentIcon
                  sx={{ marginTop: "10px" }}
                  color="primary"
                  onClick={() => {
                    navigate("./stock-care-by");
                  }}
                />
              </Tooltip>
            ) : (
              <Tooltip arrow title="Add">
                <IconButton>
                  <AddOutlinedIcon
                    onClick={() => {
                      navigate(
                        `./Edit${screenName === "Remarks"
                          ? "Delivery Chalan"
                          : screenName
                        }/-1/A`,
                        {
                          state: { ...state },
                        },
                      );
                    }}
                  />
                </IconButton>
              </Tooltip>
            )}
            {accessID == "TR048" && !doesArrayContainNegative() ? (
              <Tooltip arrow title="Production Card Issue">
                <PendingActionsIcon
                  sx={{ marginTop: "10px" }}
                  color="primary"
                  onClick={() => {
                    navigate("./TR300/Editproduction");
                  }}
                />
              </Tooltip>
            ) : (
              false
            )}
            <GridToolbarExport
              printOptions={{ disableToolbarButton: true }}
              csvOptions={{
                fileName: `${screenName}`,
              }}
              slotProps={{ toolbar: { csvOptions: { allColumns: true } } }}
            />

            <Tooltip arrow title="Logout">
              <IconButton onClick={() => fnLogOut("Logout")} color="error">
                <LogoutOutlinedIcon />
              </IconButton>
            </Tooltip>
          </Box>
        </Box>
      </GridToolbarContainer>
    );
  }

  React.useEffect(() => {
    // if (accessID == "TR263") {
    //   dispatch(
    //     FilterGetData({
    //       data: {
    //         AccessID: accessID,
    //         loginUserID: EMPID,
    //       },
    //     })
    //   );
    // }
    dispatch(fetchListview(accessID, screenName, filter, "", compID));
  }, [location.key]);

  const handlePagechange = (pageno) => {
    setPage(pageno);
    sessionStorage.setItem("secondaryCurrentPage", pageno);
  };

  async function FIlterSave(values) {
    const hasAtLeastOneValue =
      values.fromDate ||
      values.toDate ||
      values.self ||
      values.manager ||
      values.sprint ||
      values.assigned ||
      values.scheduled ||
      values.inprogress ||
      values.completed ||
      values.approved ||
      values.query ||
      values.project ||
      values.subordinates;

    const errors = {};
    if (!hasAtLeastOneValue) {
      toast.error(
        "Please fill at least one field or check at least one option.",
      );
    }
    const res = await dispatch(
      FilterPostData({
        data: {
          RecordID: "",
          Filters: JSON.stringify(values),
          AccessID: accessID,
          UserID: EMPID,
        },
      }),
    );

    if (res.payload.Status == "Y") {
      dispatch(
        FilterGetData({
          data: {
            AccessID: accessID,
            loginUserID: EMPID,
          },
        }),
      );

      const conditions = [];

      // 1. Date filter
      if (values.fromDate && values.toDate) {
        conditions.push(
          `HiddenDate BETWEEN '${values.fromDate}' AND '${values.toDate}'`,
        );
      } else if (values.fromDate) {
        conditions.push(`HiddenDate >= '${values.fromDate}'`);
      } else if (values.toDate) {
        conditions.push(`HiddenDate <= '${values.toDate}'`);
      }

      // 2. Source filter
      const sourceFilters = [];
      if (values.self) sourceFilters.push(`'Self'`);
      if (values.manager) sourceFilters.push(`'Manager'`);
      if (values.sprint) sourceFilters.push(`'Sprint'`);

      if (sourceFilters.length > 0) {
        conditions.push(`FilterSource IN (${sourceFilters.join(", ")})`);
      }

      // 3. Status filter
      const statusFilters = [];
      if (values.assigned) statusFilters.push(`'AS'`);
      if (values.scheduled) statusFilters.push(`'SH'`);
      if (values.inprogress) statusFilters.push(`'I'`);
      if (values.completed) statusFilters.push(`'C'`);
      if (values.approved) statusFilters.push(`'AP'`);
      if (values.query) statusFilters.push(`'RJ'`);

      if (statusFilters.length > 0) {
        conditions.push(`FilterStatus IN (${statusFilters.join(", ")})`);
      }

      // Final SQL WHERE clause
      let whereClause =
        conditions.length > 0
          ? ` EmployeesID IN (${values.team.length > 0
            // ? values.team.map((val) => `'${val}'`).join(",")
            ? values.team
  .map((val) => `'${val.ID || val}'`)
  .join(",")
            // : FirstLevelSub.map((val) => `'${val}'`).join(",")
            : teamData.map((val) => `'${val.ID}'`).join(",")
          },${EMPID}) AND ${conditions.join(" AND ")}`
          : "";

      if (values.project.length > 0) {
        whereClause += ` AND ProjectID IN(${values.project
          .map((val) => `'${val.RecordID}'`)
          .join(",")})`;
      }

      if ((values.manager || values.sprint) && !values.self) {
        whereClause += `AND AssignedBy IN(${EMPID})`;
      }

      if (values.manager && values.self) {
        whereClause += `AND (AssignedBy IN(${EMPID}))`;
      }
      dispatch(fetchListview(accessID, screenName, whereClause, "", compID));
      toast.success("Changes saved successfully");
    } else {
      toast.error("Error while saving filter");
    }
  }

  function getDateRange(fromDay) {
    const currentDate = new Date(); // today
    const fromDate = new Date();
    fromDate.setDate(currentDate.getDate() - fromDay); // subtract days

    // Format to YYYY-MM-DD or any format you prefer
    const formatDate = (date) => date.toISOString().split("T")[0];

    if (fromDay) {
      return {
        fromDate: formatDate(fromDate),
        currentDate: formatDate(currentDate),
      };
    } else {
      return false;
    }
  }

  let { fromDate, currentDate: currentDate1 } = getDateRange(
    filterGetData.lastDay,
  );
  return (
    <React.Fragment>
      <Box m="5px">
        <Box
          m="5px 0 0 0"
          padding={2}
          // height="85vh"
          height={dataGridHeight}
          sx={{
            "& .MuiDataGrid-root": {
              // border: "none",
            },
            "& .MuiDataGrid-cell": {
              // borderBottom: "none",
            },
            "& .name-column--cell": {
              color: colors.greenAccent[300],
            },
            "& .MuiDataGrid-columnHeaders": {
              backgroundColor: colors.blueAccent[800],
              // borderBottom: "none",
            },
            "& .MuiDataGrid-virtualScroller": {
              backgroundColor: colors.primary[400],
            },
            "& .MuiDataGrid-footerContainer": {
              // borderTop: "none",
              backgroundColor: colors.blueAccent[800],
            },
            "& .MuiCheckbox-root": {
              color: `${colors.greenAccent[200]} !important`,
            },
            "& .odd-row": {
              backgroundColor: "",
              color: "", // Color for odd rows
            },
            "& .even-row": {
              backgroundColor: "#d0edec",
              color: "", // Color for even rows
            },
            display: "flex",
            direction: "row",
          }}
        >
          <DataGrid
            sx={{
              "& .MuiDataGrid-footerContainer": {
                height: dataGridHeaderFooterHeight,
                minHeight: dataGridHeaderFooterHeight,
              },
            }}
            rowHeight={dataGridRowHeight}
            headerHeight={dataGridHeaderFooterHeight}
            key={accessID}
            rows={listViewData}
            columns={columnShow}
            page={page}
            disableSelectionOnClick
            getRowId={(row) => row.RecordID}
            pageSize={pageSize}
            onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
            rowsPerPageOptions={[5, 10, 20]}
            onPageChange={(pageno) => handlePagechange(pageno)}
            components={{
              Toolbar: () => CustomToolbar(listViewData),
            }}
            loading={loading}
            componentsProps={{
              toolbar: {
                showQuickFilter: true,
                quickFilterProps: { debounceMs: 500 },
              },
            }}
            getRowClassName={(params) =>
              params.indexRelativeToCurrentPage % 2 === 0
                ? "odd-row"
                : "even-row"
            }
          />

          {showMore && accessID === "TR263" && !is003Subscription && (
            <Box
              sx={{
                width: 300,
                p: 2,
                borderRadius: 1,
                backgroundColor: "#fff",
              }}
            >
              <Formik
                initialValues={initialFilterValues}
                // enableReinitialize
                onReset={(values, { setFieldValue }) =>
                  handleResetFilters(setFieldValue)
                }
                validate={(values) => {
                  const hasAtLeastOneValue =
                    values.fromDate ||
                    values.toDate ||
                    values.self ||
                    values.manager ||
                    values.sprint ||
                    values.assigned ||
                    values.scheduled ||
                    values.inprogress ||
                    values.completed ||
                    values.approved ||
                    values.query ||
                    values.project.length > 0 ||
                    values.team.length > 0;

                  // const errors = {};
                  // if (!hasAtLeastOneValue) {
                  //   toast.error(
                  //     "Please fill at least one field or check at least one option."
                  //   );
                  //   errors.custom =
                  //     "Please fill at least one field or check at least one option.";
                  // }
                  // return errors;
                }}
                onSubmit={(values, { setSubmitting }) => {
                  const conditions = [];

                  // Save Redux + sessionStorage
                  dispatch(setFilterGetData(values));
                  sessionStorage.setItem(
                    "TR263_Filters",
                    JSON.stringify(values),
                  );
                  Object.entries(values).forEach(([key, val]) => {
                    sessionStorage.setItem(`TR263_${key}`, JSON.stringify(val));
                  });

                  if (values.fromDate && values.toDate) {
                    conditions.push(
                      `HiddenDate BETWEEN '${values.fromDate}' AND '${values.toDate}'`,
                    );
                  }
                  const sourceFilters = [];
                  if (values.self) sourceFilters.push(`'Self'`);
                  if (values.manager) sourceFilters.push(`'Manager'`);
                  if (values.sprint) sourceFilters.push(`'Sprint'`);
                  if (sourceFilters.length > 0)
                    conditions.push(
                      `FilterSource IN (${sourceFilters.join(", ")})`,
                    );
                  const statusFilters = [];
                  if (values.assigned) statusFilters.push(`'AS'`);
                  if (values.scheduled) statusFilters.push(`'SH'`);
                  if (values.inprogress) statusFilters.push(`'I'`);
                  if (values.completed) statusFilters.push(`'C'`);
                  if (values.approved) statusFilters.push(`'AP'`);
                  if (values.query) statusFilters.push(`'RJ'`);
                  if (statusFilters.length > 0)
                    conditions.push(
                      `FilterStatus IN (${statusFilters.join(", ")})`,
                    );

                  conditions.push(`CompanyID='${compID}'`);
                  let whereClause =
                    conditions.length > 0
                      ? `EmployeesID IN (${values.team.length > 0
                        ? 
                        // values.team.map((val) => `'${val}'`).join(",")
values.team
  .map((val) => `'${val.ID || val}'`)
  .join(",")
                        // : FirstLevelSub.map((val) => `'${val}'`).join(",")
                        : teamData.map((val) => `'${val.ID}'`).join(",")
                      },${EMPID}) AND ${conditions.join(" AND ")}`
                      : "";

                  if (values.project.length > 0) {
                    whereClause += ` AND ProjectID IN(${values.project
                      .map((val) => `'${val.RecordID}'`)
                      .join(",")})`;
                  }

                  if ((values.manager || values.sprint) && !values.self) {
                    whereClause += ` AND AssignedBy IN(${EMPID})`;
                  }
                  if (values.manager && values.self) {
                    whereClause += ` AND (AssignedBy IN(${EMPID}))`;
                  }
                  if (values.TaskType && values.TaskType.length > 0) {
                    const TaskCodes = values.TaskType.map((t) => t).join("','");
                    whereClause += ` AND TaskType IN ('${TaskCodes}')`;
                  }

                  dispatch(
                    fetchListview(
                      accessID,
                      screenName,
                      whereClause,
                      "",
                      compID,
                    ),
                  );

                  setTimeout(() => setSubmitting(false), 100);
                }}
              >
                {({
                  values,
                  handleChange,
                  handleBlur,
                  handleSubmit,
                  isSubmitting,
                  setFieldValue,
                }) => (
                  <form onSubmit={handleSubmit}>
                    <Box sx={{ height: 600, overflowY: "auto" }}>
                      {/* Project multi-select */}
                      <FormGroup>
                        <IconButton
                          size="small"
                          onClick={() => setShowMore(false)}
                          sx={{ position: "absolute", top: 5, right: 4 }}
                        >
                          <Tooltip title="Close">
                            <CancelIcon color="error" />
                          </Tooltip>
                        </IconButton>
                        <MultiFormikOptimizedAutocomplete
                          sx={{ width: "100%", mt: 2 }}
                          name="ProName"
                          label="Project"
                          id="ProName"
                          value={values.project}
                          onChange={(e, newValue) =>
                            setFieldValue("project", newValue)
                          }
                          url={`${listViewurl}?data=${encodeURIComponent(
                            JSON.stringify({
                              Query: {
                                AccessID: "2114",
                                ScreenName: "Project",
                                Filter: `parentID=${compID} AND EmployeeID=${EMPID}`,
                                Any: "",
                              },
                            }),
                          )}`}
                        />
                      </FormGroup>
                      <FormControl
                        variant="standard"
                        sx={{ width: 250, mt: 2 }}
                        focused
                      >
                        <InputLabel id="TaskType-label">Task Type</InputLabel>

                        <Select
                          labelId="TaskType-label"
                          id="TaskType"
                          name="TaskType"
                          multiple
                          value={
                            Array.isArray(values.TaskType)
                              ? values.TaskType
                              : []
                          }
                          onChange={(e) => {
                            const selectedValues = e.target.value;
                            console.log("TaskType changed:", e.target.value);
                            setFieldValue("TaskType", selectedValues);
                            // sessionStorage.setItem(
                            //   "TR263_TaskType",
                            //   JSON.stringify(selectedValues),
                            // );
                          }}
                          onBlur={handleBlur}
                          renderValue={(selected) => selected.join(", ")}
                        >
                          <MenuItem value="Normal">Normal</MenuItem>
                          <MenuItem value="Learning&development">
                            Learning & development
                          </MenuItem>
                          <MenuItem value="Research&development">
                            Research & development
                          </MenuItem>
                          <MenuItem value="Up-skill">Up-skill</MenuItem>
                          <MenuItem value="Bug">Bug</MenuItem>
                          <MenuItem value="Improvements">Improvements</MenuItem>
                          <MenuItem value="Minutes of Meeting">
                            Minutes of Meeting
                          </MenuItem>
                          <MenuItem value="Script">Script</MenuItem>
                          <MenuItem value="Documentation">
                            Documentation
                          </MenuItem>
                        </Select>
                      </FormControl>

                      {/* Source */}
                      <Typography mt={2} fontWeight="bold" color="error">
                        Source
                      </Typography>
                      {["self", "manager", "sprint"].map((field) => (
                        <FormControlLabel
                          key={field}
                          control={
                            <Checkbox
                              name={field}
                              checked={values[field]}
                              onChange={(e) => {
                                const checked = e.target.checked;
                                setFieldValue(field, checked);
                                sessionStorage.setItem(
                                  `TR263_${field}`,
                                  checked ? "Y" : "N",
                                );
                              }}
                            />
                          }
                          label={field.charAt(0).toUpperCase() + field.slice(1)}
                        />
                      ))}

                      {/* Status */}
                      <Typography mt={2} fontWeight="bold" color="error">
                        Status
                      </Typography>
                      {[
                        "assigned",
                        "scheduled",
                        "inprogress",
                        "completed",
                        "approved",
                        "query",
                      ].map((field) => (
                        <FormControlLabel
                          key={field}
                          control={
                            <Checkbox
                              name={field}
                              checked={values[field]}
                              onChange={(e) => {
                                const checked = e.target.checked;
                                setFieldValue(field, checked);
                                sessionStorage.setItem(
                                  `TR263_${field}`,
                                  checked ? "Y" : "N",
                                );
                              }}
                            />
                          }
                          label={field.charAt(0).toUpperCase() + field.slice(1)}
                        />
                      ))}

                      {/* Last Days */}
                      <FormGroup sx={{ mt: 1 }}>
                        <Stack direction="row" alignItems="center" spacing={1}>
                          <Typography>Last</Typography>
                          <TextField
                            name="lastDay"
                            variant="standard"
                            type="number"
                            value={values.lastDay}
                            onChange={(e) => {
                              const val = e.target.value;
                              setFieldValue("lastDay", val);
                              sessionStorage.setItem("TR263_lastDay", val);
                              if (val) {
                                const { fromDate, currentDate } =
                                  getDateRange(val);
                                setFieldValue("fromDate", fromDate);
                                setFieldValue("toDate", currentDate);
                                sessionStorage.setItem(
                                  "TR263_fromDate",
                                  fromDate,
                                );
                                sessionStorage.setItem(
                                  "TR263_toDate",
                                  currentDate,
                                );
                              } else {
                                setFieldValue("fromDate", "");
                                setFieldValue("toDate", "");
                                sessionStorage.setItem("TR263_fromDate", "");
                                sessionStorage.setItem("TR263_toDate", "");
                              }
                            }}
                            sx={{ width: 80 }}
                          />
                          <Typography>Days</Typography>
                        </Stack>

                        {/* <TextField
                          fullWidth
                          margin="dense"
                          label="From Date"
                          type="date"
                          name="fromDate"
                          value={values.fromDate}
                          onChange={(e) => {
                            handleChange(e);
                            sessionStorage.setItem(
                              "TR263_fromDate",
                              e.target.value
                            );
                          }}
                          InputLabelProps={{ shrink: true }}
                        />
                        <TextField
                          fullWidth
                          margin="dense"
                          label="To Date"
                          type="date"
                          name="toDate"
                          value={values.toDate}
                          onChange={(e) => {
                            handleChange(e);
                            sessionStorage.setItem(
                              "TR263_toDate",
                              e.target.value
                            );
                          }}
                          InputLabelProps={{ shrink: true }}
                        /> */}
                        <TextField
                          name="fromDate"
                          type="date"
                          label="From Date"
                          value={values.fromDate}
                          onChange={(e) => {
                            const newFromDate = e.target.value;
                            setFieldValue("fromDate", newFromDate);
                            sessionStorage.setItem(
                              "TR263_fromDate",
                              newFromDate,
                            );

                            // Update combined object
                            const saved = JSON.parse(
                              sessionStorage.getItem("TR263_Filters") || "{}",
                            );
                            saved.fromDate = newFromDate;
                            sessionStorage.setItem(
                              "TR263_Filters",
                              JSON.stringify(saved),
                            );
                          }}
                          InputLabelProps={{ shrink: true }}
                          sx={{ marginTop: 2 }}
                        />

                        <TextField
                          name="toDate"
                          type="date"
                          label="To Date"
                          value={values.toDate}
                          onChange={(e) => {
                            const newToDate = e.target.value;
                            setFieldValue("toDate", newToDate);
                            sessionStorage.setItem("TR263_toDate", newToDate);

                            const saved = JSON.parse(
                              sessionStorage.getItem("TR263_Filters") || "{}",
                            );
                            saved.toDate = newToDate;
                            sessionStorage.setItem(
                              "TR263_Filters",
                              JSON.stringify(saved),
                            );
                          }}
                          InputLabelProps={{ shrink: true }}
                          sx={{ marginTop: 2 }}
                        />
                      </FormGroup>

                      {/* Team */}
                      <Typography mt={2} fontWeight="bold" color="error">
                        Team
                      </Typography>
                      <FormGroup>
                        {teamData.map((member) => (
                          <FormControlLabel
                            key={member.ID}
                            control={
                              <Checkbox
                                name="team"
                                value={member.ID}
                                // checked={values.team.includes(member.ID)}
                                checked={values.team.some((v) => (v.ID || v) === member.ID)}
                                onChange={(e) => {
                                  const id = member.ID;
                                  let updatedTeam = [...values.team];
                                  // if (e.target.checked) updatedTeam.push(id);
                                  // else
                                  //   updatedTeam = updatedTeam.filter(
                                  //     (v) => v !== id,
                                  //   );
                                  if (e.target.checked) {
                                    updatedTeam.push(member.ID);
                                  } else {
                                    updatedTeam = updatedTeam.filter(
                                      (v) => (v.ID || v) !== member.ID
                                    );
                                  }
                                  setFieldValue("team", updatedTeam);
                                   // IMPORTANT FIX
  const savedFilters = JSON.parse(
    sessionStorage.getItem("TR263_Filters") || "{}"
  );

  savedFilters.team = updatedTeam;

  sessionStorage.setItem(
    "TR263_Filters",
    JSON.stringify(savedFilters)
  );
                                  // sessionStorage.setItem(
                                  //   "TR263_team",
                                  //   JSON.stringify(updatedTeam),
                                  // );
                                }}
                              />
                            }
                            label={member.Name}
                          />
                        ))}
                      </FormGroup>
                    </Box>

                    <Stack
                      direction="row"
                      alignItems="center"
                      justifyContent="end"
                      spacing={1}
                    >
                      <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                        disabled={isSubmitting}
                      >
                        Apply
                      </Button>
                      <Button
                        variant="contained"
                        color="error"
                        onClick={() => handleResetFilters(setFieldValue)}
                      >
                        Reset
                      </Button>
                    </Stack>
                  </form>
                )}
              </Formik>
            </Box>
          )}

          {showMore && accessID === "TR353" && is003Subscription && (
            <Box
              sx={{
                width: 300,
                p: 2,
                borderRadius: 1,
                backgroundColor: "#fff",
              }}
            >
              <Formik
                initialValues={sclinitialFilterValues}
                // enableReinitialize
                onReset={(values, { setFieldValue }) =>
                  SchlhandleResetFilters(setFieldValue)
                }
                validate={(values) => {
                  const hasAtLeastOneValue =
                    values.fromDate ||
                    values.toDate ||
                    values.Teacher ||
                    // values.manager ||
                    // values.sprint ||
                    values.assigned ||
                    values.scheduled ||
                    values.inprogress ||
                    values.completed ||
                    values.approved ||
                    values.query ||
                    !!values.project ||
                    values.Milestone.length > 0 ||
                    values.team.length > 0;

                  // const errors = {};
                  // if (!hasAtLeastOneValue) {
                  //   toast.error(
                  //     "Please fill at least one field or check at least one option."
                  //   );
                  //   errors.custom =
                  //     "Please fill at least one field or check at least one option.";
                  // }
                  // return errors;
                }}
                onSubmit={(values, { setSubmitting }) => {
                  const conditions = [];

                  // Save Redux + sessionStorage
                  dispatch(setFilterGetData(values));
                  sessionStorage.setItem(
                    "TR353_Filters",
                    JSON.stringify(values),
                  );
                  Object.entries(values).forEach(([key, val]) => {
                    sessionStorage.setItem(`TR353_${key}`, JSON.stringify(val));
                  });

                  if (values.fromDate && values.toDate) {
                    conditions.push(
                      `HiddenDate BETWEEN '${values.fromDate}' AND '${values.toDate}'`,
                    );
                  }
                  const sourceFilters = [];
                  if (values.Teacher) sourceFilters.push(`'Teacher'`);
                  // if (values.manager) sourceFilters.push(`'Manager'`);
                  // if (values.sprint) sourceFilters.push(`'Sprint'`);
                  if (sourceFilters.length > 0)
                    conditions.push(
                      `FilterSource IN (${sourceFilters.join(", ")})`,
                    );
                  const statusFilters = [];
                  if (values.assigned) statusFilters.push(`'AS'`);
                  if (values.scheduled) statusFilters.push(`'SH'`);
                  if (values.inprogress) statusFilters.push(`'I'`);
                  if (values.completed) statusFilters.push(`'C'`);
                  if (values.approved) statusFilters.push(`'AP'`);
                  if (values.query) statusFilters.push(`'RJ'`);
                  if (statusFilters.length > 0)
                    conditions.push(
                      `FilterStatus IN (${statusFilters.join(", ")})`,
                    );

                  conditions.push(`CompanyID='${compID}'`);
                  let whereClause =
                    conditions.length > 0
                      ? `EmployeesID IN (${values.team.length > 0
                        // ? values.team.map((val) => `'${val}'`).join(",")
                        ? values.team
  .map((val) => `'${val.ID || val}'`)
  .join(",")
                        : teamData.map((val) => `'${val.ID}'`).join(",")
                      },${EMPID}) AND ${conditions.join(" AND ")}`
                      : "";

                  // if (values.project.length > 0) {
                  //   whereClause += ` AND ProjectID IN(${values.project.map(
                  //     (val) => `'${val.RecordID}'`,
                  //   ).join(",")})`;
                  // }
                  //                   if (values.project.length > 0) {
                  //   whereClause += ` AND ProjectID IN(${values.project
                  //     .map((val) => `'${val.RecordID}'`)
                  //     .join(",")})`;
                  // }
                  if (values.project?.RecordID) {
                    whereClause += ` AND ProjectID IN('${values.project.RecordID}')`;
                  }
                  if (values.Milestone.length > 0) {
                    whereClause += ` AND MilestoneID IN(${values.Milestone
                      .map((val) => `'${val.RecordID}'`)
                      .join(",")})`;
                  }

                  // if ((values.manager || values.sprint) && !values.self) {
                  //   whereClause += ` AND AssignedBy IN(${EMPID})`;
                  // }
                  // if (values.manager && values.self) {
                  //   whereClause += ` AND (AssignedBy IN(${EMPID}))`;
                  // }
                  if (values.TaskType && values.TaskType.length > 0) {
                    const TaskCodes = values.TaskType.join("','");
                    whereClause += ` AND FilterTaskType IN ('${TaskCodes}')`;
                  }

                  dispatch(
                    fetchListview(
                      accessID,
                      screenName,
                      whereClause,
                      "",
                      compID,
                    ),
                  );

                  setTimeout(() => setSubmitting(false), 100);
                }}
              >
                {({
                  values,
                  handleChange,
                  handleBlur,
                  handleSubmit,
                  isSubmitting,
                  setFieldValue,
                }) => (
                  <form onSubmit={handleSubmit}>
                    <Box sx={{ height: 600, overflowY: "auto" }}>
                      {/* Project multi-select */}
                      <FormGroup>
                        <IconButton
                          size="small"
                          onClick={() => setShowMore(false)}
                          sx={{ position: "absolute", top: 5, right: 4 }}
                        >
                          <Tooltip title="Close">
                            <CancelIcon color="error" />
                          </Tooltip>
                        </IconButton>
                        <CheckinAutocomplete
                          sx={{ width: "100%", mt: 2 }}
                          name="project"
                          label="Standard"
                          id="project"
                          value={values.project}
                          onChange={(newValue) => {
                            setFieldValue("project", newValue);
                            console.log(newValue, "--newvalue");

                            setFieldValue("Milestone", []); // reset milestone when project changes
                          }}
                          url={`${listViewurl}?data=${encodeURIComponent(
                            JSON.stringify({
                              Query: {
                                AccessID: "2114",
                                ScreenName: "Project",
                                Filter: `parentID='${compID}' AND EmployeeID='${EMPID}'`,
                                Any: "",
                              },
                            }),
                          )}`}
                        />
                      </FormGroup>

                      <MultiFormikOptimizedAutocomplete
                        sx={{ width: "100%", mt: 2 }}
                        name="Milestone"
                        label="Section"
                        id="Milestone"
                        value={values.Milestone}
                        onChange={(e, newValue) =>
                          setFieldValue("Milestone", newValue)
                        }
                        url={`${listViewurl}?data=${encodeURIComponent(
                          JSON.stringify({
                            Query: {
                              AccessID: "2105",
                              ScreenName: "Milestone",
                              Filter: `parentID='${values.project?.RecordID}' AND CompanyID='${compID}'`,
                              //                        Filter: `${
                              //   values.project && values.project.length > 0
                              //     ? `parentID IN (${values.project
                              //         .map((p) => `'${p.RecordID}'`)
                              //         .join(",")})`
                              //     : "1=1"
                              // } AND CompanyID='${compID}'`,
                              // Filter: `parentID IN(${values.project?.RecordID}) AND CompanyID='${compID}'`,
                              Any: "",
                            },
                          }),
                        )}`}
                      />
                      <FormControl
                        variant="standard"
                        sx={{ width: 250, mt: 2 }}
                        focused
                      >
                        <InputLabel id="TaskType-label">Task Type</InputLabel>

                        <Select
                          labelId="TaskType-label"
                          id="TaskType"
                          name="TaskType"
                          multiple
                          value={
                            Array.isArray(values.TaskType)
                              ? values.TaskType
                              : []
                          }
                          onChange={(e) => {
                            const selectedValues = e.target.value;

                            setFieldValue("TaskType", selectedValues);

                            // sessionStorage.setItem(
                            //   "TR353_TaskType",
                            //   JSON.stringify(selectedValues),
                            // );
                          }}
                          renderValue={(selected) =>
                            selected
                              .map(
                                (val) =>
                                  scltaskTypeOptions.find(
                                    (opt) => opt.value === val,
                                  )?.label,
                              )
                              .join(", ")
                          }
                        >
                          {scltaskTypeOptions.map((option) => (
                            <MenuItem key={option.value} value={option.value}>
                              {option.label}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>

                      {/* Source */}
                      <Typography mt={2} fontWeight="bold" color="error">
                        Source
                      </Typography>
                      {["Teacher"].map((field) => (
                        <FormControlLabel
                          key={field}
                          control={
                            <Checkbox
                              name={field}
                              checked={values[field]}
                              onChange={(e) => {
                                const checked = e.target.checked;
                                setFieldValue(field, checked);
                                sessionStorage.setItem(
                                  `TR353_${field}`,
                                  checked ? "Y" : "N",
                                );
                              }}
                            />
                          }
                          label={field.charAt(0).toUpperCase() + field.slice(1)}
                        />
                      ))}

                      {/* Status */}
                      <Typography mt={2} fontWeight="bold" color="error">
                        Status
                      </Typography>
                      {[
                        "assigned",
                        "scheduled",
                        "inprogress",
                        "completed",
                        "approved",
                        "query",
                      ].map((field) => (
                        <FormControlLabel
                          key={field}
                          control={
                            <Checkbox
                              name={field}
                              checked={values[field]}
                              onChange={(e) => {
                                const checked = e.target.checked;
                                setFieldValue(field, checked);
                                sessionStorage.setItem(
                                  `TR353_${field}`,
                                  checked ? "Y" : "N",
                                );
                              }}
                            />
                          }
                          label={field.charAt(0).toUpperCase() + field.slice(1)}
                        />
                      ))}

                      {/* Last Days */}
                      <FormGroup sx={{ mt: 1 }}>
                        <Stack direction="row" alignItems="center" spacing={1}>
                          <Typography>Last</Typography>
                          <TextField
                            name="lastDay"
                            variant="standard"
                            type="number"
                            value={values.lastDay}
                            onChange={(e) => {
                              const val = e.target.value;
                              setFieldValue("lastDay", val);
                              sessionStorage.setItem("TR353_lastDay", val);
                              if (val) {
                                const { fromDate, currentDate } =
                                  getDateRange(val);
                                setFieldValue("fromDate", fromDate);
                                setFieldValue("toDate", currentDate);
                                sessionStorage.setItem(
                                  "TR353_fromDate",
                                  fromDate,
                                );
                                sessionStorage.setItem(
                                  "TR353_toDate",
                                  currentDate,
                                );
                              } else {
                                setFieldValue("fromDate", "");
                                setFieldValue("toDate", "");
                                sessionStorage.setItem("TR353_fromDate", "");
                                sessionStorage.setItem("TR353_toDate", "");
                              }
                            }}
                            sx={{ width: 80 }}
                          />
                          <Typography>Days</Typography>
                        </Stack>

                        <TextField
                          name="fromDate"
                          type="date"
                          label="From Date"
                          value={values.fromDate}
                          onChange={(e) => {
                            const newFromDate = e.target.value;
                            setFieldValue("fromDate", newFromDate);
                            sessionStorage.setItem(
                              "TR353_fromDate",
                              newFromDate,
                            );

                            // Update combined object
                            const saved = JSON.parse(
                              sessionStorage.getItem("TR353_Filters") || "{}",
                            );
                            saved.fromDate = newFromDate;
                            sessionStorage.setItem(
                              "TR353_Filters",
                              JSON.stringify(saved),
                            );
                          }}
                          InputLabelProps={{ shrink: true }}
                          sx={{ marginTop: 2 }}
                        />

                        <TextField
                          name="toDate"
                          type="date"
                          label="To Date"
                          value={values.toDate}
                          onChange={(e) => {
                            const newToDate = e.target.value;
                            setFieldValue("toDate", newToDate);
                            sessionStorage.setItem("TR353_toDate", newToDate);

                            const saved = JSON.parse(
                              sessionStorage.getItem("TR353_Filters") || "{}",
                            );
                            saved.toDate = newToDate;
                            sessionStorage.setItem(
                              "TR353_Filters",
                              JSON.stringify(saved),
                            );
                          }}
                          InputLabelProps={{ shrink: true }}
                          sx={{ marginTop: 2 }}
                        />
                      </FormGroup>

                      {/* Team */}
                      <Typography mt={2} fontWeight="bold" color="error">
                        Student
                      </Typography>
                      <FormGroup>
                        {teamData.map((member) => (
                          <FormControlLabel
                            key={member.ID}
                            control={
                              <Checkbox
                                name="team"
                                value={member.ID}
                                // checked={values.team.includes(member.ID)}
                                checked={values.team.some((v) => (v.ID || v) === member.ID)}
                                onChange={(e) => {
                                  const id = member.ID;
                                  let updatedTeam = [...values.team];
                                  // if (e.target.checked) updatedTeam.push(id);
                                  // else
                                  //   updatedTeam = updatedTeam.filter(
                                  //     (v) => v !== id,
                                  //   );
                                  if (e.target.checked) {
                                    updatedTeam.push(member.ID);
                                  } else {
                                    updatedTeam = updatedTeam.filter(
                                      (v) => (v.ID || v) !== member.ID
                                    );
                                  }
                                  setFieldValue("team", updatedTeam);
                                   // IMPORTANT FIX
  const savedFilters = JSON.parse(
    sessionStorage.getItem("TR353_Filters") || "{}"
  );

  savedFilters.team = updatedTeam;

  sessionStorage.setItem(
    "TR353_Filters",
    JSON.stringify(savedFilters)
  );
                                  // sessionStorage.setItem(
                                  //   "TR353_team",
                                  //   JSON.stringify(updatedTeam),
                                  // );
                                }}
                              />
                            }
                            label={member.Name}
                          />
                        ))}
                      </FormGroup>
                    </Box>

                    <Stack
                      direction="row"
                      alignItems="center"
                      justifyContent="end"
                      spacing={1}
                    >
                      <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                        disabled={isSubmitting}
                      >
                        Apply
                      </Button>
                      <Button
                        variant="contained"
                        color="error"
                        onClick={() => SchlhandleResetFilters(setFieldValue)}
                      >
                        Reset
                      </Button>
                    </Stack>
                  </form>
                )}
              </Formik>
            </Box>
          )}

          {showFilter && accessID === "TR086" && (
            <Box
              sx={{
                width: 320,
                p: 2,
                borderRadius: 1,
                backgroundColor: "#fff",
              }}
            >
              <Formik
                initialValues={parsedFilters}
                enableReinitialize
                validate={(values) => {
                  const hasAtLeastOneValue =
                    values.projects.length > 0 ||
                    // values.Employees ||
                    values.overheads?.length > 0 ||
                    values.status ||
                    values.fromdate ||
                    values.todate;

                  const errors = {};
                  if (!hasAtLeastOneValue) {
                    toast.error(
                      "Please fill at least one field or check at least one option.",
                    );
                    errors.custom =
                      "Please fill at least one field or check at least one option.";
                  }
                  return errors;
                }}
                onSubmit={(values, { setSubmitting }) => {
                  // Continue with normal logic if valid
                  const conditions = [];
                  // const fromDate = formattedDate2(values.fromDate);
                  // const toDate = formattedDate2(values.toDate);
                  sessionStorage.setItem(
                    // "TR264_Filters",
                    "TR293_Filters",
                    JSON.stringify(values),
                  );

                  if (values.fromdate && values.todate) {
                    conditions.push(
                      `FiDate BETWEEN '${values.fromdate}' AND '${values.todate}'`,
                    );
                  }
                  if (values.status) {
                    conditions.push(`AppStatus='${values.status}'`);
                  }
                  // if (values.Employee?.length > 0) {
                  //   const empIds = values.Employee.map((e) => `'${e.RecordID || e}'`).join(",");
                  //   conditions.push(`EmployeesID IN (${empIds})`);
                  // }
                  // if (values.Employees?.RecordID) {
                  //   conditions.push(`EmployeeID IN (${values.Employees?.RecordID})`);
                  // }
                  if (values.projects?.length > 0) {
                    const projIds = values.projects
                      .map((p) => `'${p.RecordID}'`)
                      .join(",");
                    conditions.push(`ProjectID IN (${projIds})`);
                  }
                  // if (values.overheads?.RecordID) {
                  //   conditions.push(
                  //     `OverheadRecordID='${values.overheads.RecordID}'`
                  //   );
                  // }
                  if (values.overheads?.length > 0) {
                    const OHIds = values.overheads
                      .map((p) => `'${p.RecordID}'`)
                      .join(",");
                    conditions.push(`OverheadRecordID IN (${OHIds})`);
                  }

                  conditions.push(`CompanyID='${compID}'`);
                  conditions.push(`Approvedby='${EMPID}' AND type='H'`);
                  const whereClause = conditions.join(" AND ");
                  dispatch(
                    fetchListview(
                      accessID,
                      screenName,
                      whereClause,
                      "",
                      compID,
                    ),
                  );

                  setTimeout(() => setSubmitting(false), 100);
                }}
              >
                {({
                  values,
                  handleChange,
                  handleBlur,
                  handleSubmit,
                  setFieldValue,
                  isSubmitting,
                  resetForm,
                }) => (
                  <form onSubmit={handleSubmit}>
                    <Box sx={{ height: 600, overflowY: "auto" }}>
                      {/* Close Button */}
                      <IconButton
                        size="small"
                        onClick={() => setShowFilter(false)}
                        sx={{ position: "absolute", top: 5, right: 4 }}
                      >
                        <Tooltip title="Close">
                          <CancelIcon color="error" />
                        </Tooltip>
                      </IconButton>
                      {/* Project Autocomplete */}
                      <MultiFormikOptimizedAutocomplete
                        sx={{ width: "100%", mt: 2 }}
                        name="projects"
                        label="Project"
                        id="projects"
                        value={values.projects}
                        onChange={(e, newValue) =>
                          setFieldValue("projects", newValue)
                        }
                        url={`${listViewurl}?data=${encodeURIComponent(
                          JSON.stringify({
                            Query: {
                              AccessID: "2114",
                              ScreenName: "Project",
                              Filter: `parentID=${compID} AND EmployeeID=${EMPID}`,
                              Any: "",
                            },
                          }),
                        )}`}
                      />
                      {/* <CheckinAutocomplete
                        variant="outlined"
                        name="overheads"
                        label="OverHead"
                        id="overheads"
                        value={values.overheads}
                        onChange={(newValue) =>
                          setFieldValue("overheads", newValue)
                        }
                        sx={{ width: "100%", mt: 2 }}
                        url={`${listViewurl}?data={"Query":{"AccessID":"2032","ScreenName":"OverHead","Filter":"companyID='${compID}'","Any":""}}`}
                      /> */}
                      <MultiFormikOptimizedAutocomplete
                        sx={{ width: "100%", mt: 2 }}
                        name="overheads"
                        label="Overhead"
                        id="overheads"
                        value={values.overheads}
                        onChange={(e, newValue) =>
                          setFieldValue("overheads", newValue)
                        }
                        url={`${listViewurl}?data={"Query":{"AccessID":"2032","ScreenName":"OverHead","Filter":"companyID='${compID}'","Any":""}}`}
                      />
                      <TextField
                        select
                        fullWidth
                        focused
                        label="Type"
                        id="Type"
                        name="Type"
                        value={values.Type}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        variant="standard"
                        sx={{ width: "100%", mt: 2 }}
                      >
                        <MenuItem value="ByProject">By Project</MenuItem>
                        <MenuItem value="ByOverhead">By Overhead</MenuItem>
                      </TextField>
                      {/* <Employeeautocomplete
                        sx={{ width: "100%", mt: 2 }}
                        name="Employee"
                        label="Employee"
                        id="Employee"
                        value={values.Employee}
                        onChange={(newValue) => {
                          setFieldValue("Employee", newValue)
                          setFieldValue("self", false)
                        }}
                        url={`${listViewurl}?data={"Query":{"AccessID":"2101","ScreenName":"EMPLOYEETEAMS","Filter":"parentID=${EMPID}","Any":"","CompId":${compID}}}`}
                      /> */}
                      {/* <TextField
                        select
                        fullWidth
                        focused
                        label="Type"
                        id="Type"
                        name="Type"
                        value={values.Type}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        variant="standard"
                        sx={{ width: "100%", mt: 2 }}
                      >
                        <MenuItem value="ByProject">By Project</MenuItem>
                        <MenuItem value="ByOverhead">By Overhead</MenuItem>
                      </TextField> */}

                      <TextField
                        fullWidth
                        label="From Date"
                        type="date"
                        name="fromdate"
                        value={values.fromdate}
                        onChange={handleChange}
                        InputLabelProps={{ shrink: true }}
                        sx={{ width: "100%", mt: 2 }}
                        focused
                      />
                      <TextField
                        fullWidth
                        label="To Date"
                        type="date"
                        name="todate"
                        value={values.todate}
                        onChange={handleChange}
                        InputLabelProps={{ shrink: true }}
                        sx={{ width: "100%", mt: 2 }}
                        focused
                      />
                      <TextField
                        select
                        fullWidth
                        focused
                        label="Status"
                        id="status"
                        name="status"
                        value={values.status}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        variant="standard"
                        sx={{ width: "100%", mt: 2 }}
                      >
                        <MenuItem value="AL">Applied</MenuItem>
                        <MenuItem value="AP">Approved</MenuItem>
                        <MenuItem value="QR">Query</MenuItem>
                      </TextField>
                      <Stack
                        direction="row"
                        alignItems="center"
                        justifyContent="end"
                        spacing={1}
                        marginTop={2}
                      >
                        <Button
                          type="submit"
                          variant="contained"
                          color="primary"
                          disabled={isSubmitting}
                        >
                          Apply
                        </Button>
                        {values.Type === "ByProject" ? (
                          <PDFDownloadLink
                            document={
                              <ExpenseprjPDF
                                data={listViewData}
                                Project={values?.project}
                                Overhead={values?.overhead}
                                filters={{
                                  Imageurl: baseurl1,
                                  HeaderImg: HeaderImg,
                                  FooterImg: FooterImg,
                                }}
                              />
                            }
                            fileName={`Summary_${values?.Employee?.Name || "Employee"}.pdf`}
                            style={{ color: "#d32f2f", cursor: "pointer" }}
                          >
                            {({ loading }) =>
                              loading ? (
                                <PictureAsPdfIcon
                                  sx={{ fontSize: 24, opacity: 0.5 }}
                                />
                              ) : (
                                <PictureAsPdfIcon sx={{ fontSize: 24 }} />
                              )
                            }
                          </PDFDownloadLink>
                        ) : (
                          <PDFDownloadLink
                            document={
                              <ExpenseOHPDF
                                data={listViewData}
                                Project={values?.project}
                                Overhead={values?.overhead}
                                filters={{
                                  Imageurl: baseurl1,
                                  HeaderImg: HeaderImg,
                                  FooterImg: FooterImg,
                                }}
                              />
                            }
                            fileName={`Summary_${values?.Employee?.Name || "Employee"}.pdf`}
                            style={{ color: "#d32f2f", cursor: "pointer" }}
                          >
                            {({ loading }) =>
                              loading ? (
                                <PictureAsPdfIcon
                                  sx={{ fontSize: 24, opacity: 0.5 }}
                                />
                              ) : (
                                <PictureAsPdfIcon sx={{ fontSize: 24 }} />
                              )
                            }
                          </PDFDownloadLink>
                        )}
                        {/* {values.Type === "ByProject" ? (
                          <PDFDownloadLink
                            document={
                              <OnsitesummaryPDF
                                data={listViewData}
                                Project={values?.project}
                                Overhead={values?.overhead}
                                filters={{
                                  Imageurl: baseurl1,
                                  HeaderImg: HeaderImg,
                                  FooterImg: FooterImg,
                                }}
                              />
                            }
                            fileName={`Summary_${values?.Employee?.Name || "Employee"}.pdf`}
                            style={{ color: "#d32f2f", cursor: "pointer" }}
                          >
                            {({ loading }) =>
                              loading ? (
                                <PictureAsPdfIcon sx={{ fontSize: 24, opacity: 0.5 }} />
                              ) : (
                                <PictureAsPdfIcon sx={{ fontSize: 24 }} />
                              )
                            }
                          </PDFDownloadLink>
                        ) : (
                          <PDFDownloadLink
                            document={
                              <OHsummaryPDF
                                data={listViewData}
                                Project={values?.project}
                                Overhead={values?.overhead}
                                filters={{
                                  Imageurl: baseurl1,
                                  HeaderImg: HeaderImg,
                                  FooterImg: FooterImg,
                                }}


                              />
                            }
                            fileName={`Summary_${values?.Employee?.Name || "Employee"}.pdf`}
                            style={{ color: "#d32f2f", cursor: "pointer" }}
                          >
                            {({ loading }) =>
                              loading ? (
                                <PictureAsPdfIcon sx={{ fontSize: 24, opacity: 0.5 }} />
                              ) : (
                                <PictureAsPdfIcon sx={{ fontSize: 24 }} />
                              )
                            }
                          </PDFDownloadLink>
                        )} */}
                        {/* <PDFDownloadLink
                          // document={
                          //   <InvpaymentPDF
                          //     data={listViewData}
                          //     Project={values?.project}
                          //     filters={{
                          //       Imageurl: baseurl1,
                          //       HeaderImg: HeaderImg,
                          //       FooterImg: FooterImg,
                          //     }}

                          //   />
                          // }
                          fileName="Expense_Entry_pdf"
                          style={{ color: "#d32f2f", cursor: "pointer" }}
                        >
                          {({ loading }) =>
                            loading ? (
                              <PictureAsPdfIcon sx={{ fontSize: 24, opacity: 0.5 }} />
                            ) : (
                              <PictureAsPdfIcon sx={{ fontSize: 24 }} />
                            )
                          }
                        </PDFDownloadLink> */}
                        <Button
                          type="button"
                          variant="contained"
                          color="error"
                          onClick={() => {
                            sessionStorage.removeItem("TR264_Filters");
                            sessionStorage.removeItem("TR264_useCurrentEmp");

                            resetForm({
                              values: {
                                project: [],
                                overhead: [],
                                fromDate: "",
                                toDate: "",
                                status: "",
                              },
                            });
                          }}
                        >
                          RESET
                        </Button>
                      </Stack>
                    </Box>
                  </form>
                )}
              </Formik>
            </Box>
          )}
          <Dialog
            open={isReasonOpened}
            onClose={() => dispatch(isReasonOpen({}))}
          >
            <Formik
              initialValues={{
                reason: "",
              }}
              onSubmit={(values, setSubmitting) => {
                setTimeout(async () => {
                  const res = await dispatch(
                    leaveAppoval({
                      data: { ...ReasonData, Reason: values.reason },
                    }),
                  );

                  if (res.payload.Status == "Y") {
                    toast.success(res.payload.Msg);
                    dispatch(
                      fetchListview(accessID, screenName, filter, "", compID),
                    );
                    dispatch(isReasonOpen({}));
                  } else {
                    dispatch(isReasonOpen({}));
                    toast.error(res.payload.Msg);
                  }
                }, 100);
              }}
              // validationSchema={DailytaskSchema}
              enableReinitialize={true}
            >
              {({
                errors,
                touched,
                handleBlur,
                handleChange,
                isSubmitting,
                values,
                handleSubmit,
                setFieldValue,
              }) => (
                <form onSubmit={handleSubmit}>
                  <DialogTitle>Unlock reason</DialogTitle>
                  <DialogContent>
                    <DialogContentText>
                      To unlock to this Personnel, please enter your reason
                      here.
                    </DialogContentText>

                    <TextField
                      autoFocus
                      required
                      margin="dense"
                      value={values.reason}
                      onChange={handleChange}
                      id="name"
                      name="reason"
                      label="Reason"
                      type="reason"
                      fullWidth
                      variant="standard"
                    />
                  </DialogContent>
                  <DialogActions>
                    <Button onClick={() => dispatch(isReasonOpen({}))}>
                      Cancel
                    </Button>
                    <Button type="submit">Unlock</Button>
                  </DialogActions>
                </form>
              )}
            </Formik>
          </Dialog>
        </Box>
        <Box display="flex" alignItems="center" marginLeft={3}>
          <Typography fontWeight={400} fontSize={15} lineHeight={1} mb={-2}>
            Action Guide
          </Typography>
        </Box>
        {accessID == "TR001" ? (
          <Box
            display="flex"
            flexDirection="row"
            padding="25px"
            sx={{ overflowY: "auto" }}
          >
            <Chip
              icon={<ModeEditOutlinedIcon color="primary" />}
              label="Edit"
              variant="outlined"
            />
            <Chip
              icon={<ListAltOutlinedIcon color="primary" />}
              label="List of BOM"
              variant="outlined"
              sx={{ marginLeft: "50px" }}
            />
            <Chip
              icon={<ListAltOutlinedIcon color="error" />}
              label="Stock"
              variant="outlined"
              sx={{ marginLeft: "50px" }}
            />
            <Chip
              icon={<AddPhotoAlternateIcon color="primary" />}
              label="Image Upload"
              variant="outlined"
              sx={{ marginLeft: "50px" }}
            />
          </Box>
        ) : accessID == "TR263" || accessID == "TR353" ? (
          <Box
            display="flex"
            flexDirection="row"
            padding="25px"
            sx={{ overflowY: "auto" }}
          >
            <Chip
              icon={<ModeEditOutlinedIcon color="primary" />}
              label="Edit"
              variant="outlined"
            />
            <Chip
              icon={<SwapHorizIcon color="primary" />}
              label="Transfer"
              variant="outlined"
              sx={{ marginLeft: "10px" }}
            />

            <Chip
              icon={<VisibilityIcon color="primary" />}
              label="View"
              variant="outlined"
              sx={{ marginLeft: "10px" }}
            />
            {/* <Chip
              icon={<EscalatorWarningIcon color="primary" />}
              label="Dependence"
              variant="outlined"
              sx={{ marginLeft: "40px" }}
            /> */}
            <Chip
              icon={<AttachFileIcon color="primary" />}
              label="Attachment"
              variant="outlined"
              sx={{ marginLeft: "10px" }}
            />
          </Box>
        ) : // : accessID == "TR284" ? (
          //   <Box
          //     display="flex"
          //     flexDirection="row"
          //     padding="25px"
          //     sx={{ overflowY: "auto" }}
          //   >
          //     <Chip
          //       icon={<VisibilityIcon color="primary" />}
          //       label="View"
          //       variant="outlined"
          //     />
          //   </Box>
          // )
          //LIST OF ASSESSMENT
          accessID == "TR290" ? (
            <Box display="flex" flexDirection="row" padding="25px" gap={2}>
              <Chip
                icon={<FileUploadOutlinedIcon color="primary" />}
                label="Story Board"
                variant="outlined"
              />

              <Chip
                icon={<AccessTimeIcon color="primary" />}
                label="Session"
                variant="outlined"
              />
              {/* <Chip
                      icon={<AssessmentIcon color="error" />}
                      label="Start Assessment"
                      variant="outlined"
                    /> */}
              <Chip
                icon={<QuizIcon color="error" />}
                label="Start Assessment"
                variant="outlined"
              />


              {/* <Chip
                      icon={<DashboardIcon color="error" />}
                      label="View Dashboard"
                      variant="outlined"
                    /> */}
              <Chip
                icon={<AnalyticsIcon color="secondary" />}
                label="View Scoreboard"
                variant="outlined"
              />
              {/* <Chip
              icon={<CachedOutlinedIcon color="error" />}
              label="In Progress"
              variant="outlined"
            />
            <Chip
              icon={<DashboardIcon color="secondary" />}
              label="View Appraisal Scoreboard"
              variant="outlined"
            /> */}
            </Box>

          ) : //LIST OF APPRAISAL
            accessID == "TR307" ? (
              <Box display="flex" flexDirection="row" padding="25px" gap={2}>
                <Chip
                  icon={<FileUploadOutlinedIcon color="primary" />}
                  label="Story Board"
                  variant="outlined"
                />

                <Chip
                  icon={<AccessTimeIcon color="primary" />}
                  label="Session"
                  variant="outlined"
                />
                <Chip
                  icon={<QuizIcon color="error" />}
                  label="Start Appraisal"
                  variant="outlined"
                />
                <Chip
                  icon={<AnalyticsIcon color="secondary" />}
                  label="View Scoreboard"
                  variant="outlined"
                />
              </Box>
            ) : //LIST OF APPRAISAL
              accessID == "TR368" ? (
                <Box display="flex" flexDirection="row" padding="25px" gap={2}>
                  {/* <Chip
              icon={<ModeEditOutlinedIcon color="primary" />}
              label="Edit"
              variant="outlined"
            /> */}
                  {/* <Chip
              icon={<VisibilityIcon color="primary" />}
              label="View"
              variant="outlined"
            /> */}
                  <Chip
                    icon={<CalendarMonthOutlinedIcon color="primary" />}
                    label="TimeTable"
                    variant="outlined"
                  />
                  {/* <Chip
              icon={<LockResetOutlinedIcon color="error" />}
              label="Process"
              variant="outlined"
            />  */}

                </Box>
              ) : accessID == "TR352" ? (
                <Box
                  display="flex"
                  flexDirection="row"
                  padding="25px"
                  sx={{
                    overflowY: "auto",
                    gap: "20px",
                  }}
                >
                  <Chip
                    icon={<VerifiedOutlinedIcon color="secondary" />}
                    label="Verify Assessment"
                    variant="outlined"
                  />
                  <Chip
                    icon={<AnalyticsIcon color="secondary" />}
                    label="View Scoreboard"
                    variant="outlined"
                  />
                </Box>
              ) : accessID == "TR289" ? (
                <Box
                  display="flex"
                  flexDirection="row"
                  padding="25px"
                  sx={{
                    overflowY: "auto",
                    gap: "20px",
                  }}
                >
                  <Chip
                    icon={<Download color="primary" />}
                    label="Download"
                    variant="outlined"
                  />
                  <Chip
                    icon={<OpenInNewIcon color="primary" />}
                    label="Open Link"
                    variant="outlined"
                  />
                </Box>
              ) : accessID == "TR284" ? (
                <Box
                  display="flex"
                  flexDirection="row"
                  padding="25px"
                  sx={{
                    overflowY: "auto",
                    gap: "20px",
                  }}
                >
                  <Chip
                    icon={<Download color="primary" />}
                    label="Download"
                    variant="outlined"
                  />
                  <Chip
                    icon={<OpenInNewIcon color="primary" />}
                    label="Open Link"
                    variant="outlined"
                  />
                </Box>
              ) : accessID == "TR235" ? (
                <Box
                  display="flex"
                  flexDirection="row"
                  padding="25px"
                  sx={{ overflowY: "auto" }}
                >
                  <Chip
                    icon={<ModeEditOutlinedIcon color="primary" />}
                    label="Edit"
                    variant="outlined"
                  />
                  <Chip
                    icon={<AttachFileIcon color="primary" />}
                    label="Attachment"
                    variant="outlined"
                  />
                </Box>
              ) : accessID == "TR262" ? (
                <Box
                  display="flex"
                  flexDirection="row"
                  padding="25px"
                  gap={2}
                  sx={{ overflowY: "auto" }}
                >
                  <Chip
                    icon={<ModeEditOutlinedIcon color="primary" />}
                    label="Edit"
                    variant="outlined"
                  />
                  <Chip
                    icon={<AttachFileIcon color="primary" />}
                    label="Attachment"
                    variant="outlined"
                  />
                </Box>
              ) : accessID == "TR245" ? (
                <Box
                  display="flex"
                  flexDirection="row"
                  gap={1}
                  padding="25px"
                  sx={{
                    //overflowY: "auto", 
                    alignItems: "flex-start",
                    flexWrap: "wrap"
                  }}
                >
                  <Chip
                    icon={<CoPresentIcon color="primary" />}
                    label="Permission"
                    variant="outlined"
                  />
                  <Chip
                    icon={<FollowTheSignsOutlinedIcon color="primary" />}
                    label="Leave"
                    variant="outlined"
                  />
                  <Chip
                    icon={<WorkOutlinedIcon color="primary" />}
                    label="On Duty"
                    variant="outlined"
                  />
                  <Chip
                    icon={<MoreTimeOutlinedIcon color="primary" />}
                    label="Overtime"
                    variant="outlined"
                  />

                  <Chip
                    icon={<AttributionIcon color="primary" />}
                    label="Regularization"
                    variant="outlined"
                  />
                  <Chip
                    icon={<ExplicitIcon color="primary" />}
                    label="Expense"
                    variant="outlined"
                  />
                  <Chip
                    icon={<RequestQuoteOutlinedIcon color="primary" />}
                    label="Salary Advance"
                    variant="outlined"
                  />
                  <Chip
                    icon={<GroupsIcon color="primary" />}
                    label="Personnel"
                    variant="outlined"
                  />

                  <Box
                    display="flex"
                    flexDirection="column"
                    gap={1}
                    sx={{ marginLeft: "auto" }}
                  >
                    <Box display="flex" alignItems="center" gap={0.5}>
                      <FiberManualRecordIcon color="warning" fontSize="small" />
                      <Typography variant="body2">Pending Approvals</Typography>
                    </Box>
                  </Box>
                </Box>
              ) : accessID == "TR032" ? (
                <Box display="flex" flexDirection="row" padding="25px">
                  <Chip
                    icon={<ModeEditOutlinedIcon color="primary" />}
                    label="Edit"
                    variant="outlined"
                  />
                  <Chip
                    icon={<ListAltOutlinedIcon color="primary" />}
                    label="List of Color Shades"
                    variant="outlined"
                    sx={{ marginLeft: "50px" }}
                  />
                </Box>
              ) : accessID == "TR033" ? (
                <Box display="flex" flexDirection="row" padding="25px">
                  <Chip
                    icon={<ModeEditOutlinedIcon color="primary" />}
                    label="Edit"
                    variant="outlined"
                  />
                  <Chip
                    icon={<ListAltOutlinedIcon color="primary" />}
                    label="List of Customer"
                    variant="outlined"
                    sx={{ marginLeft: "50px" }}
                  />
                </Box>
              ) : accessID == "TR050" ? (
                <Box
                  display="flex"
                  flexDirection="row"
                  padding="25px"
                  sx={{ overflowY: "auto" }}
                >
                  <Chip
                    icon={<ModeEditOutlinedIcon color="primary" />}
                    label="Edit"
                    variant="outlined"
                  />
                  <Chip
                    icon={<SettingsBackupRestoreIcon color="primary" />}
                    label="Process"
                    variant="outlined"
                    sx={{ marginLeft: "50px" }}
                  />
                  <Chip
                    icon={<PrintOutlinedIcon color="primary" />}
                    label="Cutting Component"
                    variant="outlined"
                    sx={{ marginLeft: "50px" }}
                  />
                  <Chip
                    icon={<PrintOutlinedIcon color="success" />}
                    label="Production"
                    variant="outlined"
                    sx={{ marginLeft: "50px" }}
                  />
                  <Chip
                    icon={<PrintOutlinedIcon color="error" />}
                    label="Packing"
                    variant="outlined"
                    sx={{ marginLeft: "50px" }}
                  />
                  <Chip
                    icon={<PrintOutlinedIcon color="" />}
                    label="All BOM"
                    variant="outlined"
                    sx={{ marginLeft: "50px" }}
                  />
                  <Chip
                    icon={<EmailIcon color="primary" />}
                    label="Email"
                    variant="outlined"
                    sx={{ marginLeft: "50px" }}
                  />
                </Box>
              ) : accessID == "TR003" ? (
                <Box display="flex" flexDirection="row" padding="25px">
                  <Chip
                    icon={<ModeEditOutlinedIcon color="primary" />}
                    label="Edit"
                    variant="outlined"
                  />
                  <Chip
                    icon={<ListAltOutlinedIcon color="primary" />}
                    label="Material"
                    variant="outlined"
                    sx={{ marginLeft: "50px" }}
                  />
                  <Chip
                    icon={<AddPhotoAlternateIcon color="primary" />}
                    label="Image Upload"
                    variant="outlined"
                    sx={{ marginLeft: "50px" }}
                  />
                </Box>
              ) : accessID == "TR004" ? (
                <Box display="flex" flexDirection="row" padding="25px">
                  <Chip
                    icon={<ModeEditOutlinedIcon color="primary" />}
                    label="Edit"
                    variant="outlined"
                  />
                  <Chip
                    icon={<ListAltOutlinedIcon color="primary" />}
                    label="Stock"
                    variant="outlined"
                    sx={{ marginLeft: "50px" }}
                  />
                  <Chip
                    icon={<AddPhotoAlternateIcon color="primary" />}
                    label="Image Upload"
                    variant="outlined"
                    sx={{ marginLeft: "50px" }}
                  />
                </Box>
              ) : accessID == "TR097" ? (
                <Box display="flex" flexDirection="row" padding="25px">
                  <Chip
                    icon={<ListAltOutlinedIcon color="primary" />}
                    label="List of Delivery Challan"
                    variant="outlined"
                  />
                </Box>
              ) : accessID == "TR246" ||
                accessID == "TR247" ||
                accessID == "TR267" ||
                accessID == "TR248" ||
                accessID == "TR254" ||
                accessID == "TR255" ||
                accessID == "TR256" ? (
                <Box display="flex" gap={1} flexDirection="row" padding="25px">
                  <Chip
                    icon={<ModeEditOutlinedIcon color="primary" />}
                    label="Edit"
                    variant="outlined"
                  />
                  <Chip
                    icon={<CheckIcon color="success" />}
                    label="Approve"
                    variant="outlined"
                  />
                  <Chip
                    icon={<ClearIcon color="error" />}
                    label="Reject"
                    variant="outlined"
                  />
                  <Chip
                    icon={<LockOpenIcon color="success" />}
                    label="Review"
                    variant="outlined"
                  />
                </Box>
              ) : accessID == "TR111" ? (
                <Box display="flex" flexDirection="row" padding="25px">
                  <Chip
                    icon={<ListAltOutlinedIcon color="primary" />}
                    label="Edit"
                    variant="outlined"
                  />
                </Box>
              ) : accessID == "TR246" ? (
                <Box display="flex" flexDirection="row" padding="25px">
                  <Chip
                    icon={<ListAltOutlinedIcon color="primary" />}
                    label="Edit"
                    variant="outlined"
                  />
                </Box>
              ) : accessID == "TR267" ? (
                <Box display="flex" flexDirection="row" padding="25px">
                  <Chip
                    icon={<ListAltOutlinedIcon color="primary" />}
                    label="Edit"
                    variant="outlined"
                  />
                </Box>
              ) : accessID == "TR113" ? (
                <Box display="flex" flexDirection="row" padding="25px">
                  <Chip
                    icon={<ListAltOutlinedIcon color="primary" />}
                    label="Edit"
                    variant="outlined"
                  />
                </Box>
              ) : accessID == "TR048" ? (
                <Box display="flex" flexDirection="row" padding="25px">
                  <Chip
                    icon={<SummarizeOutlinedIcon color="primary" />}
                    label="Issue"
                    variant="outlined"
                  />
                </Box>
              ) : accessID == "TR118" ? (
                <Box display="flex" flexDirection="row" padding="25px">
                  <Chip
                    icon={<ListAltOutlinedIcon color="primary" />}
                    label="Edit"
                    variant="outlined"
                  />
                </Box>
              ) : accessID == "TR051" ? (
                <Box display="flex" flexDirection="row" padding="25px">
                  <Chip
                    icon={<ListAltOutlinedIcon color="primary" />}
                    label="Edit"
                    variant="outlined"
                  />
                </Box>
              ) : accessID == "TR119" ? (
                <Box display="flex" flexDirection="row" padding="25px">
                  <Chip
                    icon={<ListAltOutlinedIcon color="primary" />}
                    label="Indent Order"
                    variant="outlined"
                  />
                </Box>
              ) : accessID == "TR074" ? (
                <Box
                  display="flex"
                  flexDirection="row"
                  padding="25px"
                  sx={{ overflowY: "auto" }}
                >
                  <Chip
                    icon={<ModeEditOutlinedIcon color="primary" />}
                    label="Edit"
                    variant="outlined"
                  />
                  <Chip
                    icon={<ListAltOutlinedIcon color="primary" />}
                    label="Issue"
                    variant="outlined"
                    sx={{ marginLeft: "50px" }}
                  />
                  <Chip
                    icon={<ListAltOutlinedIcon color="error" />}
                    label="Completion"
                    variant="outlined"
                    sx={{ marginLeft: "50px" }}
                  />
                  <Chip
                    icon={<TaskAltOutlinedIcon color="success" />}
                    label="Completed"
                    variant="outlined"
                    sx={{ marginLeft: "50px" }}
                  />
                  <Chip
                    icon={<PrintOutlinedIcon color="primary" />}
                    label="Print"
                    variant="outlined"
                    sx={{ marginLeft: "50px" }}
                  />
                  <Chip
                    icon={<EmailIcon color="primary" />}
                    label="Email"
                    variant="outlined"
                    sx={{ marginLeft: "50px" }}
                  />
                </Box>
              ) : accessID == "TR087" ? (
                <Box display="flex" flexDirection="row" padding="25px">
                  <Chip
                    icon={<ModeEditOutlinedIcon color="primary" />}
                    label="Edit"
                    variant="outlined"
                  />
                  <Chip
                    icon={<PrintOutlinedIcon color="primary" />}
                    label="Print"
                    variant="outlined"
                    sx={{ marginLeft: "50px" }}
                  />
                  <Chip
                    icon={<EmailIcon color="primary" />}
                    label="Email"
                    variant="outlined"
                    sx={{ marginLeft: "50px" }}
                  />
                </Box>
              ) : accessID == "TR073" ? (
                <Box display="flex" flexDirection="row" padding="25px">
                  <Chip
                    icon={<ListAltOutlinedIcon color="primary" />}
                    label="Invoice"
                    variant="outlined"
                  />
                </Box>
              ) : accessID == "TR103" ? (
                <Box display="flex" flexDirection="row" padding="25px">
                  <Chip
                    icon={<ListAltOutlinedIcon color="primary" />}
                    label="Stock"
                    variant="outlined"
                  />
                </Box>
              ) : accessID == "TR104" ? (
                <Box display="flex" flexDirection="row" padding="25px">
                  <Chip
                    icon={<ListAltOutlinedIcon color="primary" />}
                    label="Stock"
                    variant="outlined"
                  />
                </Box>
              ) : accessID == "TR011" ? (
                <Box display="flex" flexDirection="row" padding="25px">
                  <Chip
                    icon={<ModeEditOutlinedIcon color="primary" />}
                    label="Edit"
                    variant="outlined"
                  />
                  <Chip
                    icon={<PrintOutlinedIcon color="primary" />}
                    label="Print"
                    variant="outlined"
                    sx={{ marginLeft: "50px" }}
                  />
                  <Chip
                    icon={<EmailIcon color="primary" />}
                    label="Email"
                    variant="outlined"
                    sx={{ marginLeft: "50px" }}
                  />
                </Box>
              ) : accessID == "TR084" ? (
                <Box display="flex" flexDirection="row" padding="25px">
                  <Chip
                    icon={<ModeEditOutlinedIcon color="primary" />}
                    label="Edit"
                    variant="outlined"
                  />
                  <Chip
                    icon={<PrintOutlinedIcon color="primary" />}
                    label="Print"
                    variant="outlined"
                    sx={{ marginLeft: "50px" }}
                  />
                  <Chip
                    icon={<EmailIcon color="primary" />}
                    label="Email"
                    variant="outlined"
                    sx={{ marginLeft: "50px" }}
                  />
                </Box>
              ) : accessID == "TR080" ? (
                false
              ) : accessID == "TR112" ? (
                false
              ) : accessID == "TR114" ? (
                false
              ) : accessID == "TR115" ? (
                false
              ) : accessID == "TR102" ? (
                false
              ) : accessID == "TR123" ? (
                false
              ) : accessID == "TR134" ? (
                false
              ) : accessID == "TR124" ? (
                false
              ) : accessID == "TR132" ? (
                <Box
                  display="flex"
                  flexDirection="row"
                  padding="25px"
                  gap="5px"
                  flexWrap="wrap"
                >
                  <Chip
                    icon={<ModeEditOutlinedIcon color="primary" />}
                    label="Edit"
                    variant="outlined"
                  />
                  <Chip
                    icon={<VisibilityIcon color="primary" />}
                    label="View"
                    variant="outlined"
                  />
                  <Chip
                    icon={<AssignmentTurnedInIcon color="success" />}
                    label="Completed"
                    variant="outlined"
                  />
                  <Chip
                    icon={<RedoIcon color="primary" />}
                    label="Transfer In"
                    variant="outlined"
                  />
                  <Chip
                    icon={<UndoIcon color="warning" />}
                    label="Transfer Out"
                    variant="outlined"
                  />
                  <Chip
                    icon={<BlockIcon color="primary" />}
                    label="Blocked"
                    variant="outlined"
                  />
                  <Chip
                    icon={<DoneOutlineIcon color="primary" />}
                    label="Pick Now"
                    variant="outlined"
                  />
                  <Chip
                    icon={<LockResetIcon color="primary" />}
                    label="Unblocked"
                    variant="outlined"
                  />
                  {/* <Chip
              icon={<EscalatorWarningIcon color="primary" />}
              label="Dependence"
              variant="outlined"
              sx={{ marginLeft: "40px" }}
            /> */}
                </Box>
              ) : accessID == "TR233" ? (
                <Box display="flex" flexDirection="row" padding="25px" gap="10px">

                  <Chip
                    icon={<ModeEditOutlinedIcon color="primary" />}
                    label="Edit"
                    variant="outlined"
                  />
                  {is003Subscription ? (
                    <Chip
                      icon={<DatasetLinkedIcon color="primary" />}
                      label="Timetable"
                      variant="outlined"
                    />
                  ) : (
                    <>
                      <Chip
                        icon={<ArtTrackIcon color="primary" />}
                        label="List of Stages"
                        variant="outlined"
                      />
                      <Chip
                        icon={<BalanceIcon color="primary" />}
                        label="Stage Weightage"
                        variant="outlined"
                      />

                    </>
                  )}


                </Box>
              ) : accessID == "TR236" ? (
                <Box display="flex" flexDirection="row" padding="25px" gap="5px">
                  <Chip
                    icon={<BalanceIcon color="primary" />}
                    label="Activity Weightage"
                    variant="outlined"
                  />
                  <Chip
                    icon={<ModeEditOutlinedIcon color="primary" />}
                    label="Edit"
                    variant="outlined"
                  />
                  <Chip
                    icon={<StreamIcon color="primary" />}
                    label="List of Activities"
                    variant="outlined"
                  />
                </Box>
              ) : accessID == "TR234" ? (
                <Box display="flex" flexDirection="row" padding="25px" gap="5px">
                  <Chip
                    icon={<BalanceIcon color="primary" />}
                    label="Task Weightage"
                    variant="outlined"
                  />
                  <Chip
                    icon={<ModeEditOutlinedIcon color="primary" />}
                    label="Edit"
                    variant="outlined"
                  />
                  <Chip
                    icon={<TaskIcon color="primary" />}
                    label="List of Tasks"
                    variant="outlined"
                  />
                </Box>
              ) : accessID == "TR086" ? (
                <Box display="flex" flexDirection="row" padding="25px" gap="5px">
                  <Chip
                    icon={<ModeEditOutlinedIcon color="primary" />}
                    label="Edit"
                    variant="outlined"
                  />
                  <Chip
                    icon={<AttachFileIcon color="primary" />}
                    label="Attachment"
                    variant="outlined"
                  />
                </Box>
              ) : (
                <Box display="flex" flexDirection="row" padding="25px">
                  <Chip
                    icon={<ModeEditOutlinedIcon color="primary" />}
                    label="Edit"
                    variant="outlined"
                  />
                </Box>
              )}
      </Box>
    </React.Fragment>
  );
};

export default ListviewSecondary;
